'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var toString = {}.toString;

var _cof = function (it) {
  return toString.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function (it) {
  return _iobject(_defined(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.1.15 ToLength

var min = Math.min;
var _toLength = function (it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min$1(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);
    var length = _toLength(O.length);
    var index = _toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1 = _core.version;

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _library = true;

var _shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core.version,
  mode: 'pure',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var shared = _shared('keys');

var _sharedKey = function (key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = _toIobject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document) && _isObject(document.createElement);
var _domCreate = function (it) {
  return is ? document.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && _has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? _ctx(out, _global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) _hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

// most Object methods by ES6 should accept primitives



var _objectSap = function (KEY, exec) {
  var fn = (_core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
};

// 19.1.2.14 Object.keys(O)



_objectSap('keys', function () {
  return function keys(it) {
    return _objectKeys(_toObject(it));
  };
});

var keys = _core.Object.keys;

var keys$1 = createCommonjsModule(function (module) {
module.exports = { "default": keys, __esModule: true };
});

var _Object$keys = unwrapExports(keys$1);

// true  -> String#at
// false -> String#codePointAt
var _stringAt = function (TO_STRING) {
  return function (that, pos) {
    var s = String(_defined(that));
    var i = _toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _redefine = _hide;

var _iterators = {};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);
  var keys = _objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$1 = _global.document;
var _html = document$1 && document$1.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$1 = _sharedKey('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE$1 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');
  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
  return createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = createDict();
  return Properties === undefined ? result : _objectDps(result, Properties);
};

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};

$exports.store = store;
});

var def = _objectDp.f;

var TAG = _wks('toStringTag');

var _setToStringTag = function (it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
  _setToStringTag(Constructor, NAME + ' Iterator');
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$2 = _sharedKey('IE_PROTO');
var ObjectProto = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

var ITERATOR = _wks('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!_library && typeof IteratorPrototype[ITERATOR] != 'function') _hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!_library || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    _hide(proto, ITERATOR, $default);
  }
  // Plug for library
  _iterators[NAME] = $default;
  _iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

var $at = _stringAt(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

// call something on iterator step with safe closing on error

var _iterCall = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) _anObject(ret.call(iterator));
    throw e;
  }
};

// check on default Array iterator

var ITERATOR$1 = _wks('iterator');
var ArrayProto = Array.prototype;

var _isArrayIter = function (it) {
  return it !== undefined && (_iterators.Array === it || ArrayProto[ITERATOR$1] === it);
};

var _createProperty = function (object, index, value) {
  if (index in object) _objectDp.f(object, index, _propertyDesc(0, value));
  else object[index] = value;
};

// getting tag from 19.1.3.6 Object.prototype.toString()

var TAG$1 = _wks('toStringTag');
// ES3 wrong here
var ARG = _cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

var _classof = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG$1)) == 'string' ? T
    // builtinTag case
    : ARG ? _cof(O)
    // ES3 arguments fallback
    : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

var ITERATOR$2 = _wks('iterator');

var core_getIteratorMethod = _core.getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$2]
    || it['@@iterator']
    || _iterators[_classof(it)];
};

var ITERATOR$3 = _wks('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR$3]();
  riter['return'] = function () { SAFE_CLOSING = true; };
} catch (e) { /* empty */ }

var _iterDetect = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR$3]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR$3] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

_export(_export.S + _export.F * !_iterDetect(function (iter) { }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = _toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = core_getIteratorMethod(O);
    var length, result, step, iterator;
    if (mapping) mapfn = _ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && _isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        _createProperty(result, index, mapping ? _iterCall(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = _toLength(O.length);
      for (result = new C(length); length > index; index++) {
        _createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

var from_1 = _core.Array.from;

var from_1$1 = createCommonjsModule(function (module) {
module.exports = { "default": from_1, __esModule: true };
});

unwrapExports(from_1$1);

var toConsumableArray = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _from2 = _interopRequireDefault(from_1$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};
});

var _toConsumableArray = unwrapExports(toConsumableArray);

var productTags = {
  DEFAULT_PRODUCT_TAG_COLOR: "#000000"
};

var URL_CONFIG = {
  NOT_FOUND: "/404"
};

var cdnBasePath = "https://" + process.env.REACT_APP_CDNBASEPATH;
var NOT_FOUND = {
  IMAGE: {
    DESKTOP: cdnBasePath + "/nnnow_404_web.png",
    MOBILE: cdnBasePath + "/nnnow_404_mobile.png"
  },
  TITLE: "404",
  MESSAGE: "Page Not Found",
  STATUS: 404
};

var f$1 = Object.getOwnPropertySymbols;

var _objectGops = {
	f: f$1
};

var f$2 = {}.propertyIsEnumerable;

var _objectPie = {
	f: f$2
};

// 19.1.2.1 Object.assign(target, source, ...)






var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
var _objectAssign = !$assign || _fails(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = _toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = _objectGops.f;
  var isEnum = _objectPie.f;
  while (aLen > index) {
    var S = _iobject(arguments[index++]);
    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!_descriptors || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

// 19.1.3.1 Object.assign(target, source)


_export(_export.S + _export.F, 'Object', { assign: _objectAssign });

var assign = _core.Object.assign;

var assign$1 = createCommonjsModule(function (module) {
module.exports = { "default": assign, __esModule: true };
});

unwrapExports(assign$1);

var _extends = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _assign2 = _interopRequireDefault(assign$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
});

var _extends$1 = unwrapExports(_extends);

var cdnbasepath = "https://" + process.env.REACT_APP_CDNBASEPATH;
var staticEndPoints = {
  LOADER: cdnbasepath + "/client/assets/images/icon/loader.gif",
  NOSTORES: cdnbasepath + "/nostores.gif",
  PAYTM_LOGO: cdnbasepath + "/client/assets/images/paytm_logo.jpg",
  nnnowLogoUrl: "https://cdn02.nnnow.com/web-images/master/navtree_metaData/59b2425ae4b0d70964ee66e0/1505806763887/12NNNOWLOGODESKTOP.png",
  nnnowMobileLogo: cdnbasepath + "/client/assets/images/nnnow-logo-beta_1.png",
  nnnowBaseUrl: "https://odin-qa.ailiens.com/",
  gmailLogo: cdnbasepath + "/google-social-login.svg",
  fbLogo: cdnbasepath + "/facebook.png",
  sadFaceLogo: cdnbasepath + "/sad_face.png",
  googleMapsUrl: "//maps.google.com/maps?z=12&t=m&q=",
  noImg: cdnbasepath + "/client/assets/images/icon/defaultSkuImage.png",
  fpImage: cdnbasepath + "/Forgot+password+(1).png",
  missedImage: cdnbasepath + "/phone-number.png",
  resetImage: cdnbasepath + "/reset_password.png",
  brush_stroke: cdnbasepath + "/brush-stroke.png",
  cvvImge: cdnbasepath + "/client/assets/images/checkout-final-17.png",
  favorites_no_products: cdnbasepath + "/client/assets/images/my-favorites-no-product.png",
  sadSmileyImage: cdnbasepath + "/client/assets/images/sad_smiley.png",
  noAddressImage: cdnbasepath + "/client/assets/images/address_map.jpg",
  storeLocator_illustration: cdnbasepath + "/locate+store+illustration.png",
  orderdetailsFooter: cdnbasepath + "/client/assets/images/orderdetails-footer.png",
  orderdetailsMobileFooter: cdnbasepath + "/client/assets/images/orderdetails-mobile-footer.png",
  feebackCustomerImage: {
    IMAGE: [cdnbasepath + "/client/assets/images/app/hari.png", cdnbasepath + "/client/assets/images/app/gokul.png"]
  },
  customerRating: {
    RATING: cdnbasepath + "/client/assets/images/app/ratings.png"
  },
  APP_SCREEN: cdnbasepath + "/client/assets/images/app/app-screens.jpg",
  APP_STORE: cdnbasepath + "/client/assets/images/app/apple-logo.png",
  PLAY_STORE: cdnbasepath + "/client/assets/images/app/play-logo.png",
  GETAPP: cdnbasepath + "/client/assets/appDownload.png",
  PDP_BANNER_IMAGES: {
    desktop: cdnbasepath + "/client/assets/images/pdp/pdp_desktop_1.jpg",
    mobile: cdnbasepath + "/client/assets/images/pdp/pdp_mobile_1.jpg"
  },
  LOYALTY_EXPIRY_ICON: cdnbasepath + "/loyalty_expiry.png",
  VISA_CARD: cdnbasepath + "/visa.png",
  MASTER_CARD: cdnbasepath + "/master.png",
  AMEX_CARD: cdnbasepath + "/amex.png",
  LOYALTY_GIFT_IMAGE: cdnbasepath + "/loyalty_gift.png",
  PDP_NON_RETURNABLE_LOGO: cdnbasepath + "/client/assets/images/pdp/pdp_non_returnable_logo.png",
  SIZE_NUDGE_INFO_LOGO: {
    desktop: cdnbasepath + "/client/assets/images/filter/info-logo-desktop.png",
    mobile: cdnbasepath + "/client/assets/images/filter/info-logo-mobile.png"
  }
};

var isServer = global && global.isServer || false;
var thorEndPoint = isServer && process.env.REACT_APP_THOR ? process.env.REACT_APP_THOR : process.env.REACT_APP_BACKEND_HOST;
var basePath = thorEndPoint + "/api/";
var basePathV2 = thorEndPoint + "/apiV2/";
var logInPath = process.env.REACT_APP_BLACKBOLT + "/";
var logmanPath = process.env.REACT_APP_LOGMAN_HOST + "/";

var apis = {
  basePathV1: "" + basePath,
  basePathV2: "" + basePathV2,
  masterTemplates: basePathV2 + "masterTemplates", // TODO!! to be changed back to basePathV2 once the development is completed
  getType: basePathV2 + "getType",
  mobileHeader: basePath + "header?type=website_homepage&platform=mobile",
  desktopHeader: basePathV2 + "header",
  filter: basePath + "search/filters",
  forgotPassword: logInPath + "login/users/end-user/forgot-password",
  footerLink: basePath + "footerlinks?url=" + window.location.hostname,
  storesList: basePath + "searchFulfillmentCenters?isodin=2",
  registerUser: basePath + "blackbolt/register",
  account: basePath + "account",
  mybag: basePath + "mybag/v2",
  mergeCart: basePath + "myBag/v3",
  mybagGuest: basePath + "myBag/overview/v3",
  myBagDetails: basePath + "myBag/v3",
  addToBag: basePath + "myBag/v3",
  removeFromBag: basePath + "myBag/remove/v3",
  socialLogin: logInPath + "login/users/end-user/token",
  login: logInPath + "login/users/end-user/token",
  brandList: basePath + "search/filters",
  brandListNew: basePath + "storelocator/brands/v2",
  allProductData: basePathV2 + "listing/products",
  omniFiltersData: basePathV2 + "listing/omni",
  listingDetails: basePathV2 + "listing/detailsV2",
  resetPassword: logInPath + "login/users/end-user",
  details: basePath + "product/details",
  getWishList: basePath + "fav/v2",
  setWishList: basePath + "fav/v2/products",
  getBrandWishList: basePath + "favourite",
  allFav: basePath + "fav/v2",
  setBrandWishList: basePath + "favourite/brand/",
  deleteWishList: basePath + "fav/delete",
  deleteFavProduct: basePath + "fav/delete",
  pincode: basePath + "product/shippingAndStoreDetails",
  sizeCharts: basePath + "sizeCharts",
  pincodeDetails: basePath + "shipping/pincodeDetails",
  addAddress: basePath + "shipping/address",
  shippingAddress: basePath + "address/shippingAddress",
  recentlyViewedStyles: basePath + "product/recentlyViewedStyles",
  multipleStyles: basePath + "product/multipleStyles",
  similarStyles: basePath + "product/similarStyles",
  checkout: basePathV2 + "checkout",
  checkoutStores: basePath + "shipping/v3/stores",
  generateOtp: basePath + "otp/generateOtp",
  generateOtpV2: basePathV2 + "otp/generateOtp/v1",
  resendOtp: basePath + "otp/resendOtp",
  resendOtpV2: basePathV2 + "otp/resendOtp/v1",
  validateOtp: basePath + "otp/validateOtp",
  validateOtpV2: basePathV2 + "otp/validateOtp/v1",
  addMoneyInWallet: basePathV2 + "payment/wallet/addMoney",
  getPaymentMethods: basePath + "payment/methods/v4",
  getPaymentMethodsV6: basePathV2 + "payment/methods/v6",
  cardBin: basePath + "payment",
  makePayment: basePath + "payment/makePayment/v2",
  makePaymentV2: basePathV2 + "payment/initiatePayment/v2",
  postPayment: basePathV2 + "payment/validator",
  orderDetails: basePath + "orderDetails",
  orderConfirm: basePathV2 + "order/confirmation",
  validateCaptcha: basePath + "validatecaptcha",
  changePassword: logInPath + "login/users/end-user",
  updateUserInfo: basePath + "account/userInfo",
  savedCards: basePath + "payment/savedCards",
  deletePaymentCard: basePath + "payment/deletePaymentCard",
  returnsDetails: basePath + "returns/v2",
  makeReturn: basePath + "returnInitiate",
  addNEFT: basePathV2 + "/addNeftV2",
  downloadReturnForm: logInPath + "d/api/returns/form",
  ProductOrderDetails: basePathV2 + "orderDetailsv2",
  cancelDetails: basePath + "cancel/details",
  makeCancel: basePath + "cancel/initiate",
  editAddress: basePath + "address/shippingaddress",
  noResults: basePath + "search/noResults",
  brandNewArrivals: basePath + "brand/newArrivals/",
  brandOnSale: basePath + "brand/onSale/",
  whoWeAre: basePath + "whoweare",
  customerCare: basePath + "customercare",
  termsAndCondition: basePath + "terms",
  privacyPolicy: basePath + "privacy",
  contactUs: basePath + "contactus",
  dataToLogman: "" + logmanPath,
  appLink: basePath + "appDownloadLink",
  moreInfo: basePathV2 + "loyalty/brandMoreInfo",
  loyaltyCards: basePathV2 + "loyalty/getAllBrands",
  multipleStylesDetails: basePathV2 + "product/multipleproducts",
  favBlogs: basePath + "favourite/blog",
  loyaltyPointsData: basePathV2 + "loyaltyPointsData",
  brandsList: basePathV2 + "brandListV2",
  makeExchange: basePathV2 + "mail/trigger",
  deliveryCharges: basePathV2 + "delivery_info?defaultRequired=true"
};

var apiEndpoints = _extends$1({}, apis);

var apis$1 = _extends$1({}, staticEndPoints, apiEndpoints);

var CHECKOUTPAGE = {
  CHEKOUT_EMPTY_MSG: "Oh, your bag seems empty. Start Shopping NNNOW.",
  SHOPNOW_BUTTON: "SHOP NOW",
  CONTINUE_BUTTON: "CONTINUE",
  CHECKOUT_SUBHEADER: {
    TITLE: "CHECKOUT",
    SHIPPING_BUTTON: {
      COUNT: 1,
      TEXT: "Shipping",
      ACTIVE_ROUTES: ["shipping"]
    },
    PAYMENT_BUTTON: {
      COUNT: 2,
      TEXT: "Payment",
      ACTIVE_ROUTES: ["payment", "paymentfailure"]
    }
  }
};

var CHECKOUT_BUTTON_TEXTS = {
  FAVORITE: "Move to Favorites",
  REMOVE: "Remove",
  SAVED_ADDRESSES: "SAVED ADDRESSES",
  ADD_ADDRESS: "ADD ADDRESS",
  CHANGE_ADDRESS: "CHANGE",
  DELIVER_HERE: "DELIVER HERE",
  ADD_ADDRESS_MODAl: "+ ADD ADDRESS",
  EDIT_BAG: "EDIT BAG"
};
var CHECKOUT_BASE_REQUEST = {
  graphProps: {
    isBagDetails: true,
    isPromotionDetails: true,
    isPricingOverview: true,
    isApplicablePromotions: false
  },
  type: "",
  page: "",
  guestCart: [],
  removeCart: [],
  selectedShippingMethods: [],
  updateQtyCart: []
};
var CHECKOUT_PATHNAMES = ["/mybag", "/checkout", "/checkout/shipping", "/checkout/payment"];
var CHECKOUT_ROUTES = {
  DEFAULT: "/checkout/shipping",
  SUPPORTED: {
    mybag: "/mybag",
    shipping: "/checkout/shipping",
    payment: "/checkout/payment",
    paymentfailure: "/checkout/onpaymentfailure"
  }
};
var CHECKOUT_CONFIG = {
  COOKIE_KEY: "cart-guest2",
  PROMO_KEY: "couponCode",
  PROMO_MESSAGE_TIMEOUT: 3000,
  SAVED_SHIPPING_METHODS: "savedShippingMethods",
  ADDRESS_ID: "shippingAddressId"
};
var CHECKOUT_MESSAGES = {
  NON_LOGGEDIN_CASE: {
    MESSAGE: "Please Login To Continue",
    CTA: "LOGIN"
  },
  SKU_NOT_ADDED_MESSAGE: "Sorry! $count $product in your bag has gone out of stock and couldn't be added.",
  SKU_NOT_ADDED_MESSAGE_HSN_ERROR: "Ooops! Currently this product is out of stock so couldn't be added.",
  LIMIT_BREACH_MESSAGE: "You can add only $count of $name",
  PINCODE_SCREEN_TITLE: "Enter your pincode to view shipping options",
  PAYMENT_FAILURE: {
    TITLE: "YOUR ORDER WAS NOT PLACED",
    MESSAGE: "Something went wrong. Please try again."
  },
  NO_PRODUCTS: "Oops! Your Cart is Empty",
  ADDRESS_NOT_SELECTED: "Please select a delivery address",
  DELIVERY_MISMATCH: "Oops, one of your delivery selected isn't valid anymore",
  ERROR_MESSAGE: "Oops! Something went wrong.",
  OOS_TOASTR: "Please remove out of stock items to continue",
  NON_DELIVERABLE_TOASTR: "Sorry! One or more items are not serviceable to your pincode. Try removing them to continue",
  SELECT_DELIVERY_METHOD: "Select Delivery method for each product",
  ADDRESS: {
    PINCODE_TITLE: "Shipping options for ",
    DELIVERY_ADDRESS_TITLE: "Delivery Address",
    SAVED_ADDRESSES_TITLE: "Saved Addresses",
    NEW_DELIVERY_ADDRESS_TITLE: "Add Address",
    CHANGE_ADDRESS_TITLE: "Change Address",
    DEFAULT_ADDRESS_TEXT: " (default)",
    SET_AS_DEFAULT_TEXT: "Set this as the default address",
    CITY_TEXT: "City",
    STATE_TEXT: "State",
    ADDRESS_TEXT: "Address ",
    LANDMARK_TEXT: "Landmark ",
    PINCODE_TEXT: "Pincode ",
    NAME_TEXT: "Your Name ",
    MOBILE_NO_TEXT: "Mobile number ",
    ALTERNATE_MOBILE_NO_TEXT: "Alternate Number",
    FILL_MANDATORY_FIELDS: "Please fill all the mandatory fields",
    NO_VALID_PINCODE: "Please enter a valid pincode",
    NOT_DELIVERABLE: "Sorry! we currently don't deliver to this pincode"
  },
  COUPON_TITLE: {
    APPLY: "APPLY PROMO CODE",
    CHANGE: "CHANGE PROMO CODE"
  },
  COUPON_MESSAGE: {
    SUCCESS: "Woot! You just got a discount",
    REMOVE: "Coupon has been removed from your bag",
    INVALID: "Oh no! This coupon isn't valid for your bag. Please check terms and conditions of the coupon"
  },
  STORE: {
    STORES_NEARBY: "store$count nearby",
    MORE_AVAILABLE_STORES: {
      SINGLE: "more store",
      PLURAL: "more stores"
    }
  },
  PRODUCT: {
    OOS: {
      TITLE: "Sorry! ",
      MESSAGE: "This product is Out of Stock"
    },
    NOT_SERVICEABLE: {
      TITLE: "Sorry! ",
      MESSAGE: "Delivery / Store option is not available for this location"
    },
    REMOVE: "This product has been successfully removed",
    FAVORITE: "This product has been successfully favorited",
    QTY_UPDATE: "The quantity has been successfully updated"
  },
  ORDER_CONFIRMATION: {
    NO_ORDER_ID_FOUND: "This orderId doesn't exist"
  }
};
var CHECKOUT_IMAGES = {
  PROMOTION: "https://s3-ap-southeast-1.amazonaws.com/web-resources-odin/promoicon.png"
};
var CHECKOUT_API_ACTIONS = {
  UPDATE: "update",
  DELETE: "delete",
  READ: "read"
};
var CHECKOUT_DELIVERY_OPTIONS = {
  DUMMY_TEXT: "Other Delivery Options Available",
  STOREPICK: "STOREPICK",
  DUMMY: "DUMMY",
  STANDARD: "standard",
  NDD: "ndd",
  SDD: "sdd"
};

var CHECKOUT_EXTRA_KEYS_FOR_CART = {
  FAVORITE: ["styleId", "productId"],
  REMOVE: ["productId"]
};
var STORE_CHECKOUT_IN_LOCAL = process.env.REACT_APP_STORECHECKOUT === "true";
var STAYINPAYMENT = process.env.REACT_APP_STAYINPAYMENT === "true";

var CHECKOUT_EMPTY_STATE = {
  IMAGE_ALT_TEXT: "Empty bag here"
};

var DELIVERY_CHARGES = {
  TITLE: "Delivery Charges"
};

var checkout = /*#__PURE__*/Object.freeze({
	STAYINPAYMENT: STAYINPAYMENT,
	STORE_CHECKOUT_IN_LOCAL: STORE_CHECKOUT_IN_LOCAL,
	CHECKOUT_EXTRA_KEYS_FOR_CART: CHECKOUT_EXTRA_KEYS_FOR_CART,
	CHECKOUTPAGE: CHECKOUTPAGE,
	CHECKOUT_BUTTON_TEXTS: CHECKOUT_BUTTON_TEXTS,
	CHECKOUT_BASE_REQUEST: CHECKOUT_BASE_REQUEST,
	CHECKOUT_PATHNAMES: CHECKOUT_PATHNAMES,
	CHECKOUT_ROUTES: CHECKOUT_ROUTES,
	CHECKOUT_CONFIG: CHECKOUT_CONFIG,
	CHECKOUT_MESSAGES: CHECKOUT_MESSAGES,
	CHECKOUT_IMAGES: CHECKOUT_IMAGES,
	CHECKOUT_API_ACTIONS: CHECKOUT_API_ACTIONS,
	CHECKOUT_DELIVERY_OPTIONS: CHECKOUT_DELIVERY_OPTIONS,
	CHECKOUT_EMPTY_STATE: CHECKOUT_EMPTY_STATE,
	DELIVERY_CHARGES: DELIVERY_CHARGES
});

var cdnBasePath$1 = "https://" + process.env.REACT_APP_CDNBASEPATH;
var IMAGES = {
  EMPTY_BAG_URL: cdnBasePath$1 + "/client/assets/images/checkout-final-02.png",
  SECURITY_IMAGES: [cdnBasePath$1 + "/Verified_by_Visa_logo.png", cdnBasePath$1 + "/verified-mastercard.png", cdnBasePath$1 + "/verified-pci.png", cdnBasePath$1 + "/AMEX-safekey.png"]
};
var MYBAGPAGE = {
  MAX_QTY_ALLOWED: 5,
  SHOPMORE_BUTTON: "SHOP MORE",
  CHECKOUT_BUTTON: "CHECKOUT",
  MYBAG_TEXT: "MY BAG",
  MYBAG_EMPTY_MSG: "That's one really empty bag....",
  SHOPNOW_BUTTON: "SHOP NOW",
  ADDITEMS_CTA: "+ Add items from favorites",
  ALT_IMG_TEXT: "nnnow"
};

var MYBAGPOPUP = {
  MY_BAG_TEXT: "MY BAG",
  VIEW_SHOPPING_BAG_TEXT: "VIEW SHOPPING BAG",
  TOASTER_MSG: "We've removed $styleName from your bag"
};

var DATA = { MYBAGPAGE: MYBAGPAGE, IMAGES: IMAGES, MYBAGPOPUP: MYBAGPOPUP };

var ORDERCONFIRMPAGE = {
  SUB_TITLE_TEXT: "THANKS FOR YOUR ORDER ID",
  ORDER_USER_INFO: "We’ll soon send you a confirmation email & sms on $mail & $phoneNumber respectively",
  ORDER_DELIVERY_INFO: "Having your order delivered? We’ll send you the tracking number when it ships",
  ORDER_STOREPICK_INFO: "Doing a store pick-up? We’ll notify you when your order is ready. Please show your confirmation email at the store",
  ORDER_SUMMARY_BLOCK: {
    TITLE: "Order Summary",
    ORDER_ID: "Order ID",
    ORDER_TOTAL: "Order Total",
    TOTAL_QTY: "Total Qty",
    DATE_PLACED: "Date Placed",
    PAYMENT_TYPE: "Payment",
    EXPECTED_DELIVERY: "Expected Delivery*",
    TRACK_ORDER_BTN: "TRACK ORDER",
    PRINT_ORDER_BTN: "PRINT ORDER",
    ORDER_URL_ENDPOINT: "/orderdetails/"
  },
  PRICING_DETAILS_BLOCK: {
    TITLE: "Pricing Details",
    SUBTOTAL: "Subtotal",
    SHIPPING: "Shipping",
    DISCOUNTS: "Discounts",
    TAX: "Tax",
    TOTAL: "Total",
    CURRENCY: "Rs."
  },
  ORDER_DELIVERY_DETAILS: {
    TITLE: "Delivery Details",
    SUB_TITLE_TEXT: "Your order will be delivered to this address:"
  },
  ORDER_STORE_PICKUP: {
    TITLE: "Store Pick Up",
    SUB_TITLE_TEXT_FIRST: "Your order will be confirmed via SMS and email within 30 minutes.",
    SUB_TITLE_TEXT_SECOND: "Order will be auto-cancelled if it is not picked up within 7 days"
  },
  PRODUCT_DETAILS_BLOCK: {
    TITLE: "Product",
    STATUS_TITLE: "Status",
    PRICE_TITLE: "Price",
    QTY: "Qty",
    SIZE: "Size",
    COLOR: "Colour",
    PRICE: "Unit Price",
    NO_IMAGE_TEXT: "No Image Found",
    SHIPPING_METHOD: {
      standard: "Standard Delivery",
      ndd: "Next Day Delivery",
      sdd: "Same Day Delivery",
      STOREPICK: "StorePick"
    }
  }
};

var orderConfirmation = /*#__PURE__*/Object.freeze({
	ORDERCONFIRMPAGE: ORDERCONFIRMPAGE
});

// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperty: _objectDp.f });

var $Object = _core.Object;
var defineProperty = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

var defineProperty$1 = createCommonjsModule(function (module) {
module.exports = { "default": defineProperty, __esModule: true };
});

unwrapExports(defineProperty$1);

var defineProperty$3 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _defineProperty2 = _interopRequireDefault(defineProperty$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};
});

var _defineProperty = unwrapExports(defineProperty$3);

var _RAZORPAY_DATA;

var PAYMENTPAGE = {
  OTPTHROUGHSERVICE: {
    HEIMDALL: "heimdall",
    FLASH: "flash"
  },
  OTP_MINDIGIT: 4,
  OTP_MAXDIGIT: 6,
  OTPSUCCESS: "SUCCESS!",
  PAYMENTREQUEST_FURLKEY: "paymentRequest",
  CARDPAYMENTDESCRIPTION: "card entry",
  PAYMNETBASEREQUEST: {
    bankCode: null,
    description: "",
    saveCard: false,
    savedCardPG: null,
    savedCardToken: null
  },
  SAVEFORLATER_TITLE: "save for later",
  PAYMENTOPTIONS_TITLE_WITHSAVEDCARD: "Other Payment Options",
  PAYMENTOPTIONS_TITLE_WITHOUTSAVEDCARD: "Payment Options",
  SAVECARD_TITLE: "Pay using saved cards",
  ALLBANKS: "All Banks",
  PAPULARBANKS: "Popular Banks",
  BANK_DROPDOWNTITLE: "Select Bank",
  DEFAULTSELECTED_EXPMONTH: "MM",
  DEFAULTSELECTED_EXPYEAR: "YYYY",

  MONTHLENGTH: 12,
  YEARLENGTH: 40,
  PLACEORDER_BUTTON: "PLACE ORDER",
  ORDER_REQUEST: {
    CASH_ON_DELIVERY: "CASH_ON_DELIVERY",
    CREDIT_CARD: "CREDIT_CARD",
    DEBIT_CARD: "DEBIT_CARD",
    NET_BANKING: "NET_BANKING",
    SAVEDCARD: "SAVEDCARD",
    WALLET: "WALLET",
    UPI: "UPI",
    E_WALLET: "E_WALLET",
    LOYALTY: "LOYALTY"
  },
  COMPONENTWALLET_MAPPING: {
    WALLET: "Paytm",
    CREDIT_CARD: "CreditCard",
    DEBIT_CARD: "CreditCard",
    NET_BANKING: "NetBanking",
    CASH_ON_DELIVERY: "Cod",
    SAVEDCARD: "SAVEDCARD",
    UPI: "UPI",
    EMI: "EMI",
    E_WALLET: "E_Wallet"
  },
  PAYMENTTYPE_TITLE: {
    WALLET: "Paytm Wallet",
    CREDIT_CARD: "Credit / Debit Card",
    DEBIT_CARD: "Debit Card",
    NET_BANKING: "Net Banking",
    CASH_ON_DELIVERY: "Cash on Delivery",
    UPI: "UPI",
    EMI: "EMI",
    E_WALLET: "Other Wallets"
  },
  CARD_LENGTH_FORBIN: 6,
  CARD: {
    CVVLENGTH: {
      AMEX: 4,
      DEFAULT: 3
    },
    MAXCARDLENGTH: 19,
    MINCARDLENGTH: 13
  },
  CARDTEXT: {
    CARDTITLE: "Enter your card number",
    CARDSUBTITLE: "(Visa, Mastercard, Amex)",
    CARDHOLDERTITLE: "Enter Name on Card",
    CARDCVV: "CVV"
  },
  CARD_VALIDATION_MESSAGES: {
    CARDNUMBER_VALID: "Please enter valid card details",
    CARDNUMBER_PATTERN: "Please enter card Id as Digits",
    CARDHOLDERNAME_PATTERN: "* Invalid characters",
    CVV_PATTERN: "* Not a valid CVV",
    CVV_INVALID: "Please enter a valid cvv",
    CVV_MISSING: "Hold On! Please enter a valid CVV before you proceed"
  },
  OTP_HEADING: "Verify Mobile Number",
  OTP_TOOLTIP_MSG: "This is done so that we can reach you while delivering the order.",
  OTP_SENT_MSG: "SMS with OTP Code is sent to",
  PAYTM_OTP_SENT_MSG: "Paytm has sent an otp to",
  OTP_RESND_CTA: "Resend",
  OTP_VERIFY_BTN: "VERIFY",
  OTP_PLACEHOLDER: "Please enter OTP",
  OTP_ERROR_MSG: "Invalid OTP. Please check again.",
  OTP_SUCCESS_MSG: "Mobile Number Verified.",
  OTP_SUCCESS_MSG_TIME: 5000,
  PAYTM_OTP_SUCCESS_MSG: "Yay! Paytm account linked with NNNOW",
  OTP_VALIDATE_ERROR_MSG: "Invalid OTP, please try again.",
  VALID_OTP_SIZES: [4, 5, 6],
  EXP_DATE_LABEL: "Exp. Date",
  ERRORS: {
    PAYTM_ERROR: {
      LIST: ["INSUFFICIENT_BALANCE_IN_WALLET", "NOT_ABLE_TO_CONNECT_PAYTM", "PAYTM_TOKEN_EXPIRED", "FAILED_TO_FETCH_PAYTM_OTP", "FAILED_TO_VALIDATE_PAYTM_OTP", "FAILED_TO_FETCH_BALANCE_FROM_PAYTM", "USER_NOT_REGISTERED", "PAYTM_USER_NOT_ELIGIBLE"]
    },
    WALLET_INSUFFICIENT_BALANCE: "WALLET_INSUFFICIENT_BALANCE",
    WRONG_BIN_NUMBER: "We are not able to fetch card details, Please try again",
    INVALID_BIN_NUMBER: "Invalid card number.",
    NO_PAYMENT_OPTIONS: "NO PAYMENT OPTIONS are available",
    CVV_EMPTY: "CVV is Empty",
    CVV_ERROR: "Please Enter Proper Cvv Number",
    IMS_OUT_OF_STOCK_KEY: "IMS_OUT_OF_STOCK",
    IMS_OUT_OF_STOCK: "One or more items have gone out of stock. The cart has been updated",
    OTP_NOT_VERIFIED: "Mobile Number is not Verifed",
    CAPTCHA_NOT_VERIFIED: "Captcha is not Verified",
    MOBILE_NOT_VERIFIED: "Mobile number is not verified.",
    SOMETHING_ERROR_MSG: "Something went wrong, Please try again.",
    NO_ADDRESS_SELECTED: "Please select/add a delivery address",
    NO_PAYMENT_METHOD: "Hold on! How would you like to pay for this order?",
    CARD_INFO_NOT_ENTERED: "Please enter all the card details",
    NO_BANK_SELECTED: "Please select a bank",
    NO_WALLET_SELECTED: "Please select a wallet option",
    LOYALTY_NOT_VERIFIED: "Mobile Number not verified for Loyalty",
    LOYALTY_INSUFFICIENT_BALANCE: "Insufficient Loyalty money. Please select one more payment option available",
    OTP_IS_NOT_VERIFIED: "Please enter the OTP sent by Paytm.",
    UPI_NOT_ADDED: "Please enter your UPI ID"
  },
  COD_COOKIE: {
    NAME: "codCaptcha",
    VALUE: "codOrderPlaced",
    EXPIRY: "5"
  },
  NETBANKING_REDIRECTION_MSG: "You will be re-directed to a secure payment gateway",
  PAYMENT_GATEWAYS: {
    RAZORPAY: 'razorpay',
    PAYU: 'payu'
  },
  RAZORPAY_DATA: (_RAZORPAY_DATA = {
    'EMAIL': 'email',
    'PHONE': 'phone',
    'RAZORPAY_CUSTOMER_ID': 'customerid',
    'RAZORPAY_ORDER_ID': 'orderid',
    'CCNAME': 'name',
    'ORDERID': 'orderId',
    'CCNUM': 'cardnumber',
    'CCEXPM': 'cardexpirymonth',
    'CCEXPYR': 'cardexpiry',
    'CCVV': 'cvv',
    'AMOUNT': 'amount',
    'RAZORPAY_KEY': 'key',
    'ENFORCE': 'enforce'
  }, _defineProperty(_RAZORPAY_DATA, "RAZORPAY_CUSTOMER_ID", 'RAZORPAY_CUSTOMER_ID'), _defineProperty(_RAZORPAY_DATA, 'SAVE_CARD_TOKEN', 'SAVE_CARD_TOKEN'), _RAZORPAY_DATA),
  RAZORPAY_PAYMENT_MODE: {
    'CreditCard': 'card',
    'NetBanking': 'netbanking',
    'UPI': 'upi',
    'E_Wallet': 'wallet',
    'SAVEDCARD': 'card'
  },
  PAYTM: "PAYTM_WALLET",
  LOYALTY_OTP_HEADING: "Verify OTP to apply loyalty",
  LOYALTY_POINTS_TEXT: "Use your loyalty points",
  SAVEDCARDMODAL_TITLE: "Change Card",
  SAVEDCARD_CVV_PATTERN: /^\d+$/,
  SAVEDCARDVIEW_VALIDTHROUGH: "Valid Through",
  SAVEDCARDVIEW_SELECT_BTN_TEXT: "Select",
  PAYMENTMETHODS_SUBTITLE: "PAYMENT METHODS",
  UPI_CONSTANTS: {
    VPA_TEXT: "UPI ID : ",
    VPA_PLACEHOLDER: "example@bank"
  },
  RAZORPAY_CURRENCY_INR: "INR"
};

var payment = /*#__PURE__*/Object.freeze({
	default: PAYMENTPAGE
});

var cdnBasePath$2 = "https://" + process.env.REACT_APP_CDNBASEPATH;
var PROMOTIONS = {
  APPLY_PROMO_TITLE: "apply / select promo code",
  INPUT_PLACEHOLDER: "Enter Promo",
  PROMO_APPLY_BTN: "apply promo",
  APPLY_PROMO_IMAGE: cdnBasePath$2 + "/client/assets/images/promotions/icon_promo.png"
};

var LOGIN_MESSAGES = {
  LOGINPAGE_TITLE: "login",
  LOGINPAGE_SUBTITLE: "with",
  GOOGLE_TEXT: "GOOGLE",
  FB_TEXT: "FACEBOOK",
  LOGINPAGE_PH_USERID: "Email / Phone Number",
  LOGINPAGE_PH_PASSWORD: "Password",
  FORGOT_PASS_TEXT: "forgot password?",
  LOGIN_BTN_TEXT: "LOGIN",
  NEW_USER_TEXT: "New user?",
  REGISTER_TEXT: "Register",
  REGISTERPAGE_TITLE: "register",
  REGISTERPAGE_SUBTITLE: "to your new account",
  REGISTERPAGE_PH_NAME: "Name",
  REGISTERPAGE_PH_MOBILENO: "Mobile Number",
  REGISTERPAGE_PH_EMAIL: "Email Address",
  REGISTERPAGE_PH_PASSWORD: "Password",
  FORGOTPASSPAGE_TITLE: "forgot",
  FORGOTPASSPAGE_SUBTITLE: "your password?",
  FORGOTPASSPAGE_PH_USERID: "Email / Phone Number",
  FORGOTPASSWORD_INVALID_CREDENTIALS: "Please enter valid Email / Phone Number",
  CREATEACCOUNT: "Create Account",
  BACKTOLOGIN: "Back to login",
  SUCCESSFULL_SIGNUP_MESSAGE: "Welcome, you're one of us NNNOW. Thanks for signing up.",
  FAILED_RESET_PASSWORD_MESSAGE: "Failed to reset password. Please try again later.",
  RESET_PASSWORD_SUCCESSFUL: "Your password is reset successfully.",
  MESSAGE_SENT: "sent, Please Check",
  DEFAULT_VALID_DATA_MESSAGE: "Please enter valid Data",
  UNABLE_TO_CONNECT_TO_FB: "Sorry! not able to connect to Facebook. Please try login via Email or Google",
  FAILED_TO_LOGIN_WITH_GMAIL: "Failed to Login with Gmail. Check your Gmail Credentials.",
  FB_CREDENTIAL_ERROR: "Not able to get your email or phone number from facebook",
  INVALID_DATA: "Please enter valid Data",
  INVALID_CREDENTIALS: "Please enter valid credentials",
  INVALID_ID: "Please enter valid email/phone number"
};

var login = /*#__PURE__*/Object.freeze({
	LOGIN_MESSAGES: LOGIN_MESSAGES
});

var USERNAME_REGEX = [{
  pattern: /^[a-zA-Z ]+$/,
  msg: "Name must have only alpabets"
}, {
  pattern: /^[a-zA-Z ]{3,}$/,
  msg: "Plug in atleast 3 characters."
}];

var UPI_REGEX = [{
  pattern: /^.+@.+$/,
  msg: "Invalid UPI Id"
}];

var PINCODE_REGEX = [{
  pattern: /[1-9][0-9]{5}/,
  msg: "We need a valid 6-digit pincode. Try again, please."
}];

var ADDRESS_REGEX = [{
  pattern: /^[ A-Za-z0-9_\.\/#\-,`'()]*$/,
  msg: "We allow only the following characters - a-z, 0-9, -/#().' and ,"
}, {
  pattern: /^[\s.]*([^\s.][\s.]*){3,}$/,
  msg: "Please enter your address."
}];

var MOBILE_NUMBER_REGEX = [{
  pattern: /^[6789]\d{9}$/,
  msg: "Enter 10 digits valid phone number."
}];

var NEFT_FORM_NAME_REGEX = function NEFT_FORM_NAME_REGEX(minCharErrMsg, invalidErrMsg) {
  if (minCharErrMsg && minCharErrMsg.length && invalidErrMsg && invalidErrMsg.length) {
    return [{
      pattern: /^[a-zA-Z ]+$/,
      msg: "Alphabets only, please"
    }, {
      pattern: /^[a-zA-Z ]{3,}$/,
      msg: "Please enter your " + minCharErrMsg
    }];
  }
  return USERNAME_REGEX;
};

var ACCOUNT_NUMBER_REGEX = [{
  pattern: /^\S+$/,
  msg: "Please enter your Account Number!"
}];

var SPECIAL_CHAR_REGEX = /[^A-Z0-9]+/gi;

var regex = /*#__PURE__*/Object.freeze({
	USERNAME_REGEX: USERNAME_REGEX,
	SPECIAL_CHAR_REGEX: SPECIAL_CHAR_REGEX,
	PINCODE_REGEX: PINCODE_REGEX,
	ADDRESS_REGEX: ADDRESS_REGEX,
	MOBILE_NUMBER_REGEX: MOBILE_NUMBER_REGEX,
	NEFT_FORM_NAME_REGEX: NEFT_FORM_NAME_REGEX,
	ACCOUNT_NUMBER_REGEX: ACCOUNT_NUMBER_REGEX,
	UPI_REGEX: UPI_REGEX
});

var COMPONENTS_AT_SECTION_LEVEL = ["storyGrid"];

var sectionTypes = ["section", "primaryStorySection", "secondaryStorySection", "tertiaryStorySection", "primaryStories"];

var MANDAROTY_FULLWIDTH_COMPONENTS = ["leftNav", "productCarousal", "NewArrival", "bannerCarousel", "heroBanner", "topBanner", "paddingComponent", "storyCarousel", "storyGrid"];
var NOPADDING_COMPONENTS = ["paddingComponent"];
var DEFAULT_IMAGE_DIMENTIONS = { defaultWidth: 309, defaultHeight: 400 };
var BT = "BaseTemplate";

var masterTemplate = /*#__PURE__*/Object.freeze({
	COMPONENTS_AT_SECTION_LEVEL: COMPONENTS_AT_SECTION_LEVEL,
	sectionTypes: sectionTypes,
	MANDAROTY_FULLWIDTH_COMPONENTS: MANDAROTY_FULLWIDTH_COMPONENTS,
	NOPADDING_COMPONENTS: NOPADDING_COMPONENTS,
	DEFAULT_IMAGE_DIMENTIONS: DEFAULT_IMAGE_DIMENTIONS,
	BT: BT
});

var PRICINGOVERVIEW = {
  TOTAL_PAYABLE: "Total Payable Amount",
  CURRENCY: "Rs.",
  DISCOUNT_CURRENCY: "- Rs.",
  OVERVIEW: "Overview",
  TEXT: {
    subtotal: "Subtotal",
    discounts: "Discount",
    tax: "GST",
    shippingCost: "Delivery Charges",
    loyalty: "Loyalty",
    netAmount: "Net Amount"
  },
  TOTAL: {
    total: "Total"
  }
};

var RETURNFLOW = {
  returnOrCancelReason: {
    next: "returnModes",
    previous: null,
    inner: null
  },
  returnModes: {
    next: "returnOrCancelRefund",
    previous: "returnOrCancelReason",
    inner: "returnAddress"
  },
  returnOrCancelRefund: {
    next: "returnOrCancelComplete",
    previous: "returnModes",
    inner: "addNeft"
  },
  returnOrCancelComplete: {
    next: null,
    previous: "returnOrCancelRefund",
    inner: null
  },
  returnAddress: {
    next: null,
    previous: "returnModes",
    inner: null
  },
  addNeft: {
    next: "returnOrCancelRefund",
    previous: "returnOrCancelRefund",
    inner: null
  }
};

var RETURN_MODES = {
  REVERSEPICKUP: "REVERSEPICKUP",
  SELFSHIP: "SELFSHIP"
};

var RETURN_REASONS = {
  TITLE: "Return",
  REASON_SELECTION_HEADER: "Reason for returning",
  REASON_SELECTION_PLACEHOLDER: "Select Reason",
  COMMENT_HEADER: "Additional comments",
  COMMENT_PLACEHOLDER: "Let us know what happened so that we can improve upon.",
  MAXLENGTH: "500",
  ERROR_MESSAGE: "Oops! Something went wrong."
};

var RETURN_REFUND = {
  TITLE: "Return",
  REFUND_AMOUNT_TITLE: "REFUND AMOUNT",
  REFUND_INTO_TEXT: "WILL BE REFUNDED TO",
  REFUND_INTO_SOURCE_TEXT: "Source",
  ADD_NEFT_TEXT: "ADD NEW NEFT DETAILS"
};

var ADD_ADDRESS = {
  controls: {
    firstName: "Name*",
    lastName: "LAST NAME",
    address: "Address*",
    landmark: "Landmark",
    phone: "Phone*",
    alternateNumber: "Alternate Number",
    pincode: "Pincode*",
    city: "City",
    state: "State",
    nationality: "Nationality"
  },
  EDIT: {
    submit: "UPDATE",
    title: "Edit Address"
  },
  ADD: {
    title: "Add Address",
    submit: "SAVE"
  },
  PINCODE_ERROR_MSG: "This pincode is not serviceable.",
  DEFAULT_PINCODE_ERROR_MSG: "Oops! Something went wrong. Please try again later."
};

var RETURN_COMPLETE = {
  COMPLETE_BUTTON: "DOWNLOAD FORM",
  COMPLETE_ID: "ID: ",
  COMPLETE_IMAGE: "https://d2ew2jx6vkwv1p.cloudfront.net/client/assets/returns/images/vector-smart-object.png",
  COMPLETE_MESSAGE1: "Your return form has been mailed to you at",
  COMPLETE_MESSAGE2: "Please print the form and put it in the package with the product you are returning.",
  COMPLETE_MESSAGE3: "Your Refund will be processed in 5-7 days, after we receive the product.",
  COMPLETE_TITLE: "Return Initiated!",
  CONFIRMATION_CLASS: "nw-returns-confirmation",
  DOWNLOAD_FORM_TITLE: "downloadReturnForm",
  ERROR_MESSAGE: "Oops! Something went wrong."
};
var RETURN_ELIGIBLE = "RETURN";

var ADDRESS = {
  TITLE: "My Addresses",
  NO_ADDRESS: "No Addresses here",
  START_SHOPPING: "Start shopping for your shipping address to appear"
};
var ADDR_NOT_SERVICIBLE = "Not eligible for Pickup";

var EXCHANGE_INITIATE = {
  TITLE: "Exchange",
  USERBLOCK: "Hi",
  MSG: "We’ll quickly check & get back to you about availability of an Exchange.",
  SIZEBLOCK0: "Please tell us the ",
  SIZEBLOCK1: "Size ",
  SIZEBLOCK2: "you would like to order for this product.",
  BUTTONTEXT: "SUBMIT",
  PLACEHOLDER: "Enter size",
  MAIL_SUBJECT: "NNNOW - Exchange Request",
  EXCHANGE_TEMPLATE_ID: "emailExchangeRequest",
  MESSAGE: "Initiate Exchange",
  ERROR_MESSAGE: "Oops! Something went wrong."
};

var EXCHANGE_COMPLETE = {
  TITLE: "Thank you!",
  MESSAGE1: "Exchange request received,",
  MESSAGE2: "we’ll get back to you in 5-6 business hours (9AM - 10PM)."
};

var returns = /*#__PURE__*/Object.freeze({
	RETURNFLOW: RETURNFLOW,
	RETURN_MODES: RETURN_MODES,
	ADD_ADDRESS: ADD_ADDRESS,
	RETURN_REASONS: RETURN_REASONS,
	RETURN_REFUND: RETURN_REFUND,
	RETURN_COMPLETE: RETURN_COMPLETE,
	RETURN_ELIGIBLE: RETURN_ELIGIBLE,
	ADDRESS: ADDRESS,
	ADDR_NOT_SERVICIBLE: ADDR_NOT_SERVICIBLE,
	EXCHANGE_INITIATE: EXCHANGE_INITIATE,
	EXCHANGE_COMPLETE: EXCHANGE_COMPLETE
});

var CANCELFLOW = {
  returnOrCancelReason: {
    next: "returnOrCancelRefund",
    previous: null,
    inner: null
  },
  returnOrCancelRefund: {
    next: "returnOrCancelComplete",
    previous: "returnOrCancelReason",
    inner: 'addNeft'
  },
  returnOrCancelComplete: {
    next: null,
    previous: "returnOrCancelRefund",
    inner: null
  },
  addNeft: {
    next: "returnOrCancelRefund",
    previous: "returnOrCancelRefund",
    inner: null
  }
};

var CANCEL_REASONS = {
  TITLE: "Cancel",
  REASON_SELECTION_HEADER: "Reason for cancelling",
  REASON_SELECTION_PLACEHOLDER: "Select Reason",
  COMMENT_HEADER: "Additional comments",
  COMMENT_PLACEHOLDER: "Let us know what happened so that we can improve upon.",
  MAXLENGTH: "255",
  CANCEL_FAILURE_STATUS: 400
};

var CANCEL_COMPLETE = {
  COMPLETE_IMAGE: "https://d2ew2jx6vkwv1p.cloudfront.net/client/assets/returns/images/vector-smart-object.png",
  COMPLETE_TITLE: "Cancel Initiated!",
  CONFIRMATION_CLASS: "nw-returns-confirmation",
  COMPLETE_MESSAGE: "Your refund will be processed in 5-7 days."
};
var CANCEL_ELIGIBLE = "CANCEL";

var cancel = /*#__PURE__*/Object.freeze({
	CANCELFLOW: CANCELFLOW,
	CANCEL_REASONS: CANCEL_REASONS,
	CANCEL_COMPLETE: CANCEL_COMPLETE,
	CANCEL_ELIGIBLE: CANCEL_ELIGIBLE
});

var _ORDER_DETAILS;

var ORDER_DETAILS_MESSAGES = {
  ERROR_MESSAGE: "Oops! Something went wrong."
};

var MY_ORDERS = {
  BUTTON_TEXT: "view details"
};

var ORDER_DETAILS = (_ORDER_DETAILS = {
  ORDERDETAILS_FOOTER: {
    MESSAGE: "You need some help?",
    CONTACT_US: "CONTACT US"
  },
  CURRENCY: "Rs",
  CAROUSEL_SIZE: {
    XS: 1,
    SM: 3,
    MD: 3,
    LG: 3
  },
  APP_BREAKPOINTS: {
    XS: 768,
    SM: 992,
    MD: 1200
  },
  PRICE_OVERVIEW_TITLE: "PRICE DETAILS",
  DELIVERY_STATUS_TITLE: "STATUS",
  TRACKING_TITLE: "TRACKING NUMBER",
  DELIVERY_ADDRESS_TITLE: "DELIVERY ADDRESS",
  STORE_PICK: "Store Pickup"
}, _defineProperty(_ORDER_DETAILS, "CAROUSEL_SIZE", 3), _defineProperty(_ORDER_DETAILS, "TRACKING_LINK", "TRACK IT"), _defineProperty(_ORDER_DETAILS, "ORDER_SUMMARY", {
  TITLE: "Order Summary",
  ORDERED_ON: "ORDERED ON",
  STATUS: "STATUS",
  ORDER_NUMBER: "ORDER NUMBER",
  PRODUCTS: "PRODUCTS",
  PAYMENT_METHOD: "PAYMENT METHOD"
}), _ORDER_DETAILS);

var RETURN_ELIGIBLE$1 = "RETURN";
var CANCEL_ELIGIBLE$1 = "CANCEL";
var EXCHANGE_ELIGIBLE = "EXCHANGE";

var orderDetails = /*#__PURE__*/Object.freeze({
	MY_ORDERS: MY_ORDERS,
	ORDER_DETAILS: ORDER_DETAILS,
	ORDER_DETAILS_MESSAGES: ORDER_DETAILS_MESSAGES,
	RETURN_ELIGIBLE: RETURN_ELIGIBLE$1,
	CANCEL_ELIGIBLE: CANCEL_ELIGIBLE$1,
	EXCHANGE_ELIGIBLE: EXCHANGE_ELIGIBLE
});

var MYACCOUNT = {
  INFO_FORM_LABELS: {
    EMAIL: "Email",
    NAME: "Name",
    PHONE: "Phone Number",
    PASSWORD: "Password"
  },
  CTAS: {
    CHANGE: "change",
    EDIT: "edit",
    SAVE: "save",
    SAVING: "saving"
  },
  PLACEHOLDERS: {
    USER_NAME: "So we know how to call you",
    EMAIL: "For a secure shopping experience",
    PHONE_NUMBER: "So we can save your info",
    PASSWORD: "So you can sign in"
  },
  SHOW_SUBTITLES: false
};

var CHANGE_PASSWORD = {
  title: "Change Password",
  currentPasswordText: "Current Password",
  newPasswordText: "New Password",
  confirmPasswordText: "Confirm Password",
  MISMATCH_ERROR_MSG: "Passwords do not match",
  SUBMIT: "CHANGE PASSWORD"
};

var MY_ACCOUNT_MENU = [{
  color: "blue",
  iconName: "icomoon-person1",
  title: "My Information",
  type: "user-information",
  subtitle: "Update your name and password."
}, {
  color: "loyalty",
  iconName: "icomoon-loyalty_main",
  title: "My Loyalty",
  type: "loyalty",
  subtitle: "Loyalty points details",
  hash: "#loyalty"
}, {
  color: "green",
  iconName: "icomoon-home",
  title: "My Addresses",
  type: "address",
  subtitle: "Managing your existing addresses or add a new one."
}, _defineProperty({
  color: "yellow",
  iconName: "icomoon-credit-card",
  title: "My Payment Methods",
  type: "payment-methods",
  subtitle: "Update your name and password."
}, "subtitle", "Manage your credit and debit cards.")];

var ACCOUNT_SAVED_CARDS = {
  CARD_NUMBER: "CARD NUMBER",
  VALID: "VALID TRHOUGH",
  REMOVE_BUTTON: "Remove",
  NO_CARD: "You have not set up any payment methods yet."
};

var ACCOUNT_ADDRESS_LIST = {
  noAddressComponentTitle: "No Addresses Here",
  noAddressComponentSubHeader: "Start shopping for your shipping address to appear",
  addAddressButton: "ADD ADDRESS"
};

var IFSC_CODE = {
  invalidIFSC: "Not a valid IFSC Code, please check"
};

var USER_NAME_INPUT = {
  invalidUserName: "Name must have only alphabets",
  minmumCharacters: "Plug in atleast 3 characters"
};

var FAVORITES = {
  EMPTY_MSG: "Got your eye on something?",
  EMPTY_SUBMSG_LINE1: "Add it to this Short List till you decide",
  EMPTY_SUBMSG_LINE2: "you've just got to have it",
  SHOP_NNNOW_BTN: "SHOP NNNOW",
  PRODUCT_DELETED: "The product is deleted from here.",
  PRODUCT_ADDED: "We've added this product to your bag",
  COLOR_LABEL: "Color",
  FAV_TITLE: "MY FAVORITES",
  CTAS: {
    MOVE_TO_BAG: "Move to Bag",
    REMOVE: "Remove",
    SHARE: "Share"
  }
};

var LOYALTY = {
  NO_LOYALTY_MSG: "No Loyalty Data Available",
  MORE_INFO: "More Info",
  TIER: "Tier",
  POINTS: "Points",
  VALUE: "Value",
  LOYALTY_TIER: "Tier",
  UPGRADE_CRITERIA: "Upgrade Criteria",
  EARN: "Earn",
  BURN: "Burn",
  CONVERSION: "Conversion",
  EXPIRY: "Expiry",
  TIER_DOWNGRADE: "Tier Downgrade",
  MORE_INFO_TITLE_SUFFIX: "Loyalty Program",
  NO_TIERS_MSG: "No Loyalty tiers found for this brand"
};

var myaccount = /*#__PURE__*/Object.freeze({
	MYACCOUNT: MYACCOUNT,
	CHANGE_PASSWORD: CHANGE_PASSWORD,
	MY_ACCOUNT_MENU: MY_ACCOUNT_MENU,
	ACCOUNT_SAVED_CARDS: ACCOUNT_SAVED_CARDS,
	ACCOUNT_ADDRESS_LIST: ACCOUNT_ADDRESS_LIST,
	IFSC_CODE: IFSC_CODE,
	USER_NAME_INPUT: USER_NAME_INPUT,
	FAVORITES: FAVORITES,
	LOYALTY: LOYALTY
});

var FAVORITES$1 = {
  EMPTY_MSG: "Got your eye on something?",
  EMPTY_SUBMSG_LINE1: "Add it to your favourites till you decide,",
  EMPTY_SUBMSG_LINE2: "you've just got to have it",
  SHOP_NNNOW_BTN: "SHOP NNNOW",
  PRODUCT_DELETED: "The product is deleted from here.",
  PRODUCT_ADDED: "We've added this product to your bag",
  COLOR_LABEL: "Color",
  FAV_TITLE: "MY FAVOURITES",
  OUT_OF_STOCK: "OUT OF STOCK",
  CTAS: {
    MOVE_TO_BAG: "Move to Bag",
    REMOVE: "Remove",
    SHARE: "Share"
  }
};

var favorites = /*#__PURE__*/Object.freeze({
	FAVORITES: FAVORITES$1
});

var SCROLLTOTOP_EXCLUDEDPAGES = ["product-listing-anonymous"];
var SCROLLTOTOP_EXCLUDEDPATHS = ["/search", "/products", "/customercare"];
var DEF_API_TIMEOUT = 60000;
var SSR_CACHING_CONFIGS = {
  maxAge: 1000 * 60 * 2,
  max: 500
};

var generalConfigs = /*#__PURE__*/Object.freeze({
	SCROLLTOTOP_EXCLUDEDPAGES: SCROLLTOTOP_EXCLUDEDPAGES,
	SCROLLTOTOP_EXCLUDEDPATHS: SCROLLTOTOP_EXCLUDEDPATHS,
	DEF_API_TIMEOUT: DEF_API_TIMEOUT,
	SSR_CACHING_CONFIGS: SSR_CACHING_CONFIGS
});

var DESKTOP_ACCORDION = [{
  type: "FinerDetails",
  text: "THE FINER DETAILS",
  keyToBeChecked: "finerDetails",
  isShown: true
}, {
  type: "ManufacturerDetails",
  text: "Manufacturer Details",
  keyToBeChecked: "manufacturerDetails",
  isShown: true
}, {
  type: "About",
  text: "About %brand%",
  keyToBeChecked: "about",
  isShown: true
}, {
  type: "Returns",
  text: "RETURNS & EXCHANGES",
  keyToBeChecked: "returnable",
  isShown: true
}, {
  type: "Says",
  text: "NNNOW SAYS",
  keyToBeChecked: "story",
  isShown: true
}];

var MOBILE_ACCORDION = [{
  type: "FinerDetails",
  text: "THE FINER DETAILS",
  keyToBeChecked: "finerDetails",
  isShown: true,
  isOpen: false
}, {
  type: "ManufacturerDetails",
  text: "Manufacturer Details",
  keyToBeChecked: "manufacturerDetails",
  isShown: true,
  isOpen: false
}, {
  type: "About",
  text: "About %brand%",
  keyToBeChecked: "about",
  isShown: true,
  isOpen: false
}, {
  type: "Returns",
  text: "RETURNS & EXCHANGES",
  keyToBeChecked: "returnable",
  isShown: true,
  isOpen: false
}, {
  type: "Says",
  text: "NNNOW SAYS",
  keyToBeChecked: "story",
  isShown: true,
  isOpen: false
}];
var ABOUT_TEXT = "Says";
var PDP_CONFIG = {
  MAX_QTY: "You Can Add Max $sellableQuantity Quantity of This Item.",
  OOS_MESSAGE: "Sorry! This Product is Out Of Stock.",
  ADD_TO_BAG_SUCCESS: "We've added this product to your bag",
  ACCORDION_CONFIG: { DESKTOP_ACCORDION: DESKTOP_ACCORDION, ABOUT_TEXT: ABOUT_TEXT, MOBILE_ACCORDION: MOBILE_ACCORDION },
  PDP_DETAILS_BLOCK: {
    ADD_TO_BAG_STATE: "ADD TO BAG",
    CHECKOUT_STATE: "CHECKOUT"
  },
  PRODUCT_RIGHT_PANEL: {
    ADD_TO_BAG_BUTTON: "ADD TO BAG"
  }
};

var SHOP_ALL_STYLES = {
  TOGGLE_TITLE: "Click to toggle selection",
  OUT_OF_STOCK_TEXT: "OUT OF STOCK",
  LIMIT_BREACH: "Well, it looks like you tried to add a few items more than their maximum allowed quantity. Don't worry, we've added the maximum allowed",
  ADD_TO_BAG_ERROR: "well that's embaressing! Please try again.",
  ADD_WHILE_ADDING: "Jumping the gun eh? Please wait till we finish",
  ATLEAST_ONE_PRODUCT: "Please select atleast one item to add",
  ADD_TO_BAG_SUCCESS: "Yay! We've added the items to your bag.",
  SCROLL_TIME: 300,
  SELECT_SIZE_TEXT: "Please select a size for all the selected items",
  BUTTON_TEXT: "SHOP ALL STYLES",
  PRODUCT_COUNT_TEXT: " Product$plural",
  TOTAL_TEXT: "Total: ",
  ADD_TO_BAG_TEXT: "ADD TO BAG",
  DEFAULT_SKU_SELECT: {
    discountInPercentage: 0,
    inStock: true,
    maxQuantityDisplayed: 5,
    mrp: 5599,
    price: 5599,
    sellableQuantity: 30,
    size: "Select",
    skuId: "0"
  },
  SIZE_TEXT: "Size:",
  QTY_TEXT: "Qty:",
  COLOR_TEXT: "Color:"
};

var SHOP_MULTILPE = { SHOP_ALL_STYLES: SHOP_ALL_STYLES };

var SHARE = {
  TWITTER_EXTENSION: "https://twitter.com/intent/tweet?url=",
  PINTEREST_EXTENSION: "http://pinterest.com/pin/create/button/?url=",
  FB_SHARE_TITLE: "nnnow",
  WHATSAPP_EXTENSION_MOBILE: "whatsapp://send?text=",
  WHATSAPP_EXTENSION_DESKTOP: "https://web.whatsapp.com/send?text="
};

var FAV = {
  SUCCESSFULL_ADD: "Good mooove! This item has been added to your favourites.",
  SUCCESSFULL_REMOVED: "This item has been removed from your favourites.",
  ERROR: "Oops! Something went wrong. Please try again later."
};

var FAVNSHARE = { SHARE: SHARE, FAV: FAV };

var DEFAULT_FOOTER_DOCS = [];
var SPECIFIC_PAGES = {
  Style: [],
  HOME: [{
    footerTitle: "Online Fashion Shopping on NNNOW.com",
    footerDescription: 'NNNOW.com is the digital destination of Arvind Lifestyle Brands Limited - for you, this means NNNOW.com is the official online store India’s largest and most loved brands. Topping the charts are <a href="https://gap.nnnow.com/">Gap</a>, Sephora, U. S. Polo Assn., Flying Machine, Arrow, Gant, Unlimited and many more!'
  }, {
    footerTitle: "Why buy on NNNOW?",
    footerDescription: "What’s the big deal about shopping on a brand’s official online store, you say? For starters, you get access to 100% of the styles that a brand has to offer in a season, (something no other website can promise). If you don’t like missing out, NNNOW.com should be your go-to site for the hottest and the best in online fashion shopping experience. Secondly, don’t we all hate fake merchandize? Well, a brand’s official website gives a 100% guarantee of authenticity and quality so that you can go on shopping without a worry in the world!"
  }, {
    footerTitle: "One-stop Destination for your Favourite Brands & Categories",
    footerDescription: 'If you’re the kind of person for whom <a href="https://uspoloassn.nnnow.com/us-polo-assn-polo-shirts">polo shirts only from U. S. Polo Assn</a>, Sweatshirts and <a href="https://gap.nnnow.com/gap-t-shirts">T-shirts only from Gap</a>, cosmetics only from <a href="https://sephora.nnnow.com/">Sephora</a>, jeans and jackets only from Flying machine, work wear only from Arrow and everyday outfits only from the best brands will do, you’ll find your soul mate in NNNOW.'
  }, {
    footerTitle: "",
    footerDescription: "To make the deal sweeter, when you shop on NNNOW.com you enjoy benefits that you’ll find nowhere else. For example, if your online order doesn’t fit you well, you can get it altered, returned or exchanged at a store near you for free! In case you’re in a hurry, you can place an order online and pick it up from your nearest store too. Wow! This just keeps getting better, right? But, we’ve saved the best for the last."
  }, {
    footerTitle: "Earn reward points on every purchase",
    footerDescription: "No truly authentic branded shopping experience is complete if you can’t earn and spend branded reward points. And we’ve taken care of that on NNNOW.com. Every time you buy from us you’ll earn reward points just the way you would, had you shopped at any of our branded outlets. You can also spend your reward points online or at any store you visit."
  }, {
    footerTitle: "",
    footerDescription: "Welcome to NNNOW.com - the future of online shopping."
  }]
};
var FOOTER = { DEFAULT_FOOTER_DOCS: DEFAULT_FOOTER_DOCS, SPECIFIC_PAGES: SPECIFIC_PAGES };

var PRICE_FILTER = {
  NUMBERS_ONLY: "Numbers only, please.",
  ALL_BOXES: "Please enter both Min & Max.",
  GREATER: "Max price should be > Min price, please.",
  ALL_PRICE_RANGES_BUTTONTEXT: "All Price Ranges",
  PLACEHOLDERS: {
    MIN: "Min",
    MAX: "Max"
  },
  HYPHEN: "-",
  FILTER_NAME: "customPriceFilter",
  AMOUNT_LIMIT: 1000000,
  AMOUNT_LIMIT_ERROR: "Please enter an amount below Rs. 10 Lacs",
  NO_ZERO_START: "Sorry! price cannot start with 0.",
  ERROR_TIMEOUT: 5000,
  KEYBOARD_INACTIVE_TIMEOUT: 2000
};

var APPLY_CANCEL_BUTTON = {
  CANCEL: "Clear all",
  APPLY: "APPLY"
};

var OFFER_TEXT = "OFFER";

//SizeNudgeBlock
var SIZENUDGEBLOCK_TEXT = "Please select a size before selecting stores for more relevant results";

var LISTING = { PRICE_FILTER: PRICE_FILTER, APPLY_CANCEL_BUTTON: APPLY_CANCEL_BUTTON, OFFER_TEXT: OFFER_TEXT, SIZENUDGEBLOCK_TEXT: SIZENUDGEBLOCK_TEXT };

var LOYALTY_EARN_POINTS_TEXT = "YOU'VE EARNED LOYALTY POINTS!";
var LOYALTY_REDEEM_POINTS_TEXT = "Redeem your reward points at any of our brand’s stores near you.";
var LOYALTY_POINTS_LINK_TEXT = "Check your Loyalty Points";
var LOYALTY_TABLE_HEADINGS = ["Brands", "Points Earned", "Loyalty Value", "Loyalty Balance"];
var LOYALTY_SUMMARY_TEXT1 = "HERE'S";
var LOYALTY_SUMMARY_TEXT2 = "SUMMARY OF YOUR";
var LOYALTY_POINTS_TEXT = "LOYALTY POINTS";

var LOYALTY_BLOCK_MESSAGES = {
  ERROR_MESSAGE: "Oops! Something went wrong while fetching Loyalty Data."
};

var loyalty = /*#__PURE__*/Object.freeze({
	LOYALTY_EARN_POINTS_TEXT: LOYALTY_EARN_POINTS_TEXT,
	LOYALTY_POINTS_LINK_TEXT: LOYALTY_POINTS_LINK_TEXT,
	LOYALTY_REDEEM_POINTS_TEXT: LOYALTY_REDEEM_POINTS_TEXT,
	LOYALTY_TABLE_HEADINGS: LOYALTY_TABLE_HEADINGS,
	LOYALTY_SUMMARY_TEXT1: LOYALTY_SUMMARY_TEXT1,
	LOYALTY_SUMMARY_TEXT2: LOYALTY_SUMMARY_TEXT2,
	LOYALTY_POINTS_TEXT: LOYALTY_POINTS_TEXT,
	LOYALTY_BLOCK_MESSAGES: LOYALTY_BLOCK_MESSAGES
});

var header = {
  HIGHLIGHTED_HEADINGS: [],
  SEARCHBAR_SUGGESTIONS_HEADING: "Popular Searches",
  SEARCHBAR_RECENTS_HEADING: "Recently Searched",
  SEARCHBAR_INVAIDSEARCHMESSAGE: "Please input something to search...",
  SEARCHBAR_PLACEHOLDER: "Search ",
  DEFAULT_SEARCHBRAND: "NNNOW"
};

var BRANDSLIST = {
  HOME_MASONRY_COLUMN_COUNT: { xs: 12, sm: 4 },
  BRAND_MASONRY_COLUMN_COUNT: { xs: 12, sm: 3 },
  SCROLL_X: 0,
  BRANDSLIST_HEADER_TITLE: "BRAND DIRECTORY",
  INVALID_INPUT_ERR_MSG: "Please enter something to search",
  TRENDING_KEY: "Trending",
  SEARCH_REGEX: /\s/g,
  VALIDATE_VALUE_REGEX: /^[a-zA-z0-9 ]*$/,
  VIEWALL_KEY: "View All",
  HREF_SUFFIX: "//",
  ERROR_MSG: "Oops! Something went wrong. Please try again later.",
  HOME_JOURNEY_BRAND_FILTER: "se",
  QUERY_ERROR_MSG: "Please enter a valid brand to search"
};

var CANONICALTYPE = {
  canonicalStatus: "canonical",
  permanentRedirectionStatus: "301"
};
var PROTOCOL = {
  HTTP: "http",
  HTTPS: "https"
};
var defaultSubDomainWww = "www";
var MAXREDIRECTIONALLOWED = 2;
var META = { CANONICALTYPE: CANONICALTYPE, PROTOCOL: PROTOCOL, defaultSubDomainWww: defaultSubDomainWww, MAXREDIRECTIONALLOWED: MAXREDIRECTIONALLOWED };

var SSR_CACHING_EXCLUDED_PATHS = ["store-locator", "mybag", "account", "checkout", "orderdetails", "myorders", "orderconfirmation", "favorites", "whoweare", "customercare", "termsconditions", "contactus", "privacypolicy", "noresults", "apps", "reset-password", "404", "apple-app-site-association", "brandslist"];
var NECESSARY_CACHING_PARAMS = ["at", "f-ge", "f-br", "cid", "cpr", "f-ad", "f-ag", "f-age", "f-al", "f-ar", "f-ben", "f-bl", "f-brist", "f-ca", "f-ch", "f-cl", "f-co", "f-coi", "f-col", "f-coll", "f-com", "f-conc", "f-cov", "f-cu", "f-cuf", "f-de", "f-den", "f-deni", "f-di", "f-dia", "f-dial", "f-dial-d", "f-dial-t", "f-dim", "f-dis", "f-dr", "f-dro", "f-dt", "f-ea", "f-em", "f-ex", "f-fa", "f-fe", "f-fea", "f-fi", "f-fin", "f-fl", "f-fli", "f-form", "f-fr", "f-fra", "f-frag-fam", "f-fram", "f-frame", "f-he", "f-hee", "f-ho", "f-ing-pref", "f-je", "f-kn", "f-la", "f-le", "f-len", "f-li", "f-ma", "f-me", "f-mo", "f-mu", "f-ne", "f-no", "f-ns", "f-oc", "f-pa", "f-pad", "f-pan", "f-pe", "f-pl", "f-pla", "f-po", "f-pow", "f-pr", "f-pro", "f-prod", "f-pf", "f-re", "f-sh", "f-si", "f-sk-tp", "f-sl", "f-slo", "f-so", "f-sp", "f-st", "f-str", "f-stra", "f-strap", "f-strap-c", "f-su-pr", "f-to", "f-tr", "f-tro", "f-trol", "f-ty", "f-up", "f-us", "f-use", "f-wa", "f-wal", "f-war", "f-wat", "f-watc", "f-wate", "f-water", "f-we", "f-wi", "ifr", "na", "os", "p", "p-dl", "p-st", "q", "qa", "r", "v", "sort", "style", "category", "gender", "brand", "baseurl", "iframeview", "id", "type", "lbn", "storeId", "module", "cmsPreview", "priority"];

var caching = /*#__PURE__*/Object.freeze({
	SSR_CACHING_EXCLUDED_PATHS: SSR_CACHING_EXCLUDED_PATHS,
	NECESSARY_CACHING_PARAMS: NECESSARY_CACHING_PARAMS
});

var STORE_LOCATOR_TIMINGS = {
  openingTime: "11AM",
  closingTime: "10PM"
};

var PRICE_INFO_BLOCK = {
  headerTitle: "PRICE DETAILS:",
  mrpBlockTitle: "Maximum Retail Price",
  mrpBlockSubTitle: "(inclusive of all taxes)",
  sellingPriceTitle: "Selling Price",
  youSaveTitle: "You Save",
  youSaveMsgPrefix: "Overall you save ",
  youSaveMsgSuffix: " on this product."
};

var _ref;

var BRAND_NAME = "NNNOW";
var cdnBasePath$3 = "https://" + process.env.REACT_APP_CDNBASEPATH;
var brandFilterKeys = ["ABC", "DEF", "GHI", "JKL", "MNO", "PQR", "STU", "VWX", "YZ#"];
var test = "a";
var expiryTime = 1528897271083;
var filterInitialLength = 14;
var filterKeys = {
  Color: "f-co",
  Price: "f-pr",
  Occasion: "f-oc",
  Brand: "f-br",
  delivery_time: "f-dt"
};

var searchQuerySeparator = "--";
var subPromoSeparator = "__";
var priceSeparator = "-";
var FOOTER_TEXTS = {
  PRIVACY_POLICY: "Privacy Policy",
  TNC: "Terms & Conditions"
};
var footerUrls = {
  privacytext: "Privacy Policy",
  tnctext: "Terms & Conditions",
  privacypolicy: "/privacypolicy",
  termsconditions: "/termsconditions",
  whoweare: "/whoweare",
  customercare: "/customercare",
  contactus: "/contactus",
  facebook: "https://www.facebook.com/heynnnow",
  intagram: "https://www.instagram.com/heynnnow"
};
var WHO_WE_ARE = {
  leftNav: {
    title: "NNNOW",
    navListItems: [{ text: "About NNNOW", url: "#aboutnnnow" }, {
      text: "About Arvind Fashions Limited",
      url: "#aboutarvindfashionslimited"
    }]
  },
  rightSideContent: [{
    title: "1900s",
    content: "The Swadeshi Movement boycotts imported textiles"
  }, {
    title: "1930s",
    content: "Three Lalbhai brothers set up a mill for fine fabric"
  }, {
    title: "1990s",
    content: "Arvind becomes the world’s third-largest denim manufacturer"
  }, {
    title: "2000s",
    content: "Arvind Mills renamed Arvind Limited. Vision: House of Brands Pioneers in bringing global fashion to India"
  }, {
    title: "2013s",
    content: "Arvind Internet Ltd founded to enable Arvind’s e-commerce vision"
  }, {
    title: "2014s",
    content: "Custom clothing experience Creyate launches, with you as designer"
  }, {
    title: "2015s",
    content: "Online-only fast fashion labels SHUFFLE and PRYM enter the market"
  }, { title: "2016s", content: "Est. since NNNOW" }],
  mobileLeftNav: {
    title: "Browse :",
    navListItems: ["About NNNOW", "About Arvind Fashions Limited"]
  }
};

var CUSTOMER_CARE = {
  leftNav: {
    title: "Frequently asked questions",
    navListItems: [{ text: "About NNNOW", url: "#aboutnnnow" }, { text: "Your Account", url: "#youraccount" }, { text: "Your Order", url: "#yourorder" }, { text: "Delivery & tracking", url: "#deliverytracking" }, { text: "Returns & Exchanges", url: "#returnsexchanges" }, { text: "Cancellations", url: "#cancellations" }, { text: "And More", url: "#andmore" }]
  },
  mobileLeftNav: {
    title: "Browse :",
    navListItems: ["About NNNOW", "Your Account", "Your Order", "Delivery & tracking", "Returns & Exchanges", "Cancellations", "And More"]
  }
};

var TERMS_AND_CONDITIONS = {
  title: "Terms & Conditions"
};

var PRIVACY_POLICY = {
  title: "Privacy Policy"
};

var CONTACT_US = {
  title: "Contact Us",
  message1: {
    message: "Call us",
    info: "080 4646 5500",
    detail: "Monday - Sunday (9am - 10pm)"
  },
  message2: {
    message: "Email us",
    info: "care@nnnow.com"
  },
  formTitle: "Send us a message",
  label1: "Your Name *",
  label2: "Your Email *",
  label3: "Subject *",
  label4: "Message *",
  label5: "SUBMIT",
  successMessage: "Yay! thanks for reaching out to us.\n We'll get back to you shortly.",
  invalidSubjectErrorMsg: "Subject must have only alphabets and numbers",
  minInputSubjectErrorMsg: "Plug in atleast 3 characters."
};
var CONTACT_US_V2 = {
  title: "CONTACT US",
  FAQ: "/customercare",
  message1: {
    message: "FREQUENTLY ASKED QUESTIONS",
    info: "Know everything you need to know about your order here"
  },
  message2: {
    message: "CALL US",
    info: "080 4646 5500",
    detail: "Monday - Sunday (9am - 10pm)",
    visibility: false
  },
  message3: {
    message: "EMAIL US",
    info: "care@nnnow.com",
    detail: "You will hear back us from within 24 hrs."
  },
  formTitle: "Send us a message",
  label1: "Your Name *",
  label2: "Your Email *",
  label3: "Subject *",
  label4: "Message *",
  label5: "SUBMIT",
  successMessage: "Yay! thanks for reaching out to us.\n We'll get back to you shortly.",
  invalidSubjectErrorMsg: "Subject must have only alphabets and numbers",
  minInputSubjectErrorMsg: "Plug in atleast 3 characters.",
  errorMsg: "Oops! Something went wrong."
};

var STATICPAGE_HEADER_COLOR_CLASSES = ["nw-whoweare-desktopcolor", "nw-customercare-desktopcolor", "nw-contactus-color", "nw-terms-color", "nw-privacy-color"];

var facebook = {
  appId: process.env.REACT_APP_FACEBOOK,
  version: "v2.11",
  scope: "email",
  url: "//connect.facebook.net/en_US/all.js",
  xfbml: true
};
var gmail = {
  appId: process.env.REACT_APP_GMAIL,
  cookiepolicy: "single_host_origin",
  scope: "profile email"
};

var pageType = {
  listing: "product-listing-anonymous",
  brands: "brands",
  pdp: "product-display",
  storeLocator: "store-locator",
  home: "home",
  searchPage: "search",
  myBag: "mybag",
  checkout: "checkout",
  shipping: "checkout",
  payment: "payment",
  orderConfirmation: "orderconfirmation",
  myAccount: "account",
  favourite: "favorites.shortlist",
  categoryTwoTemplate: "CategoryTemplateII",
  orderDetails: "orderdetails",
  resetPassword: "/reset-password",
  myOrders: "myorders",
  favorites: "favorites",
  getApp: "get-app",
  notFound: "notfound",
  brandslist: "brandslist"
};
var omniViewimageBasePath = cdnBasePath$3 + "/client/assets/images/omnipopup/";

var scrollTime = {
  slow: 1000,
  fast: 100
};

var AFFILIATE_EXPIRY = 43200; // 2592000000 Milliseconds = 43200 mintues.
var blackBoltUrl = ["token", "login", "phase2", "registerUser", "forgotPassword"];
var blackboltConfig = {
  ERROR_MSG: "Oops! Something went wrong. Please try again later.",
  RESET_ERROR_MSG: "This reset link is already used once, please do forgot password again",
  RESET_PASSWORD_MISMATCH: "Passwords don't match. Please enter same password.",
  RESET_PASSWORD_SUCCESS: "Your password is reset successfully.",
  RESET_PASSWORD_TEXT: "RESET PASSWORD",
  RESET_PASSWORD_NULL: "Enter your password",
  RESET_PASSWORD_LOGGEDIN: "Hey, You are already Logged-In!!",
  grant_type: "password",
  email: "EMAIL",
  mobile: "SMS",
  socialGrantType: "social_token",
  google: "GOOGLE",
  facebook: "FACEBOOK",
  ERROR_CODE: ["409", "401", "404", "403", "400", "302"],
  channel: "odin",
  CHANGE_INFO_SUCCESS: "Your changes have been saved .",
  FILL_MANDATORY_FIELDS: "Please fill all the mandatory fields"
};
var blackBoltVersion = "v2";
var requiredKeysForListing = ["q", "sort", "p-st", "p-dl", "r"];
var DEF_META_DATA = {
  title: "NNNOW.com Discover and Shop Latest Fashion and Clothes Online.",
  description: "Online Shopping for Men, Women and Kids. Buy a wide range of clothes, apparel, accessories, shoes online at NNNOW.com. Fast shipping , 15 days Return,  Cash on Delivery",
  keywords: "Online shopping, Online shopping India, Men shopping, women online shopping, Shop for accessories, shop for clothing, kids online shopping, Arrow, Gap, Sephora, U. S. Polo Assn., Aeropostale, Gant, Nautica, Flying Machine, The Children’s Place, Ed Hardy, True Blue, Elle, Izod, Ruf & Tuf, Unlimited",
  imageURL: cdnBasePath$3 + "/client/assets/images/nnnow-logo-200.png",
  pageURL: "https://www.nnnow.com",
  fb_appID: "383470072074863",
  google_site_verification: "P5hXMQ-ATML8ShhpCLa_wzcyFwyGRsJdr92b6YuBSIg",
  content: "NNNNOW"
};

var PDP_RETURNS = {
  returnPolicy: 'How to return this item? Ship it back to NNNOW or have us pick it up within 15 days. Just keep it unwashed, undamaged and with tags intact so it passes our quality checks. See <a class="nw-pdp-desktopaccordiontnc" href="/customercare" target="_blank">FAQs</a> on our Returns Policy for more.',
  noReturnPolicy: "This item can’t be returned — our Returns Policy doesn’t cover innerwear, lingerie, fragrances and beauty products."
};
var PDP_CAROUSEL_DEFAULT_VIEWALL_TEXT = "VIEW ALL";
var PDP_CAROUSEL_SIZE = {
  XS: 2,
  SM: 2,
  MD: 3,
  LG: 5
};

var LOGMAN_SERVICE_NAME = "NNNOW";
var PDP_CAROUSEL_HEADINGS = {
  IN_THIS_LOOK: "IN THIS LOOK",
  SIMILAR_PRODUCTS: "SIMILAR PRODUCTS",
  RECENTLY_VIEWED: "RECENTLY VIEWED"
};
var APP_BREAKPOINTS = {
  XS: 768,
  SM: 992,
  MD: 1200
};
var FB_SHARE_TITLE = "odin NNNOW";

var STORAGE_KEYS = {
  RECENTLY_VIEWED: "recentlyViewedItems",
  LAST_USED_PINCODE: "recentlyUsedPincode",
  UTM_MEDIUM: "utm_medium"
};

var CACHE_SETTINGS = {
  DONOT_CACHE: {
    "Cache-Control": "no-store, no-cache, must-revalidate"
  }
};

var HOME_PAGE_URL = process.env.REACT_APP_BASE_PATH_URL;
var DONOT_SHOW_OCCASION_FILTER_IDS = ["se"];
var PDP_CAROUSEL_MAX_LIMIT = 20;
var STATIC_GETTYPE_RESPONSE = {
  staticPage: true,
  documentType: null,
  type: ""
};

var ROUTE_PATHS = {
  LOYALTY: "/account#loyalty",
  ACCOUNT: "/account",
  CONTACTUS: "/contactus",
  FAVORITES: "/favorites",
  MYBAG: "/mybag",
  MYORDERS: "/myorders",
  STORELOCATOR: "/store-locator",
  SHORTLISTS: "/favorites/shortlists",
  LISTING: "/products"
};
var STATIC_HEADER_ROUTES = ["mybag", "checkout"];

var STATIC_ROUTES = {
  NEW: ["product-listing", "products", "search", "store-locator", "mybag", "account", "checkout", "orderdetails", "myorders", "orderconfirmation", "favorites", "whoweare", "customercare", "termsconditions", "contactus", "noresults", "apps", "reset-password", "404", "apple-app-site-association", "brandslist"],
  OLD: ["apple-app-site-association", "logs", "sdtnc", "gaptncs", "loyalty", "heynnnow", "sitemap", "mynow", "payment", "shortlists", "brands", "stories", "returns", "product-chooser", "choose-method", "store-selector", "neft", "confirmation", "blog-landing", "BlogPageII", "BlogPageI", "BlogPageIII", "ss16-end-of-season-sale", "storebrand", "customer-login", "logout", "mygapstore"]
};
var EXCLUDE_STORY_BACKGROUND_COLOR = ["homeMasterTemplate", "brandMasterTemplate"];
var enableCollectionSSR = false;
var GETTYPE_PAGEWISE_VALUES = {
  UNKNOWN: ["unknown"],
  LISTING: ["Collection", "ProductListBanner", "Brand"],

  // TODO products to be pushed
  STATIC_LISTING_ROUTE: ["styles"],
  PDP: ["Style"],
  MASTER_TEMPLATE: ["HMT2", "homeMasterTemplate", "brandMasterTemplate", "collectionMasterTemplate", "categoryMasterTemplate", "BrandMasterTemplate2", "BrandMasterTemplate3", "GenericTemplate", "WdBlogMock", "MasterGenericTemplate", "BaseTemplate"]
};
var SUPPORTED_GETTYPE_VALUES = (_ref = []).concat.apply(_ref, _toConsumableArray(_Object$keys(GETTYPE_PAGEWISE_VALUES).map(function (item) {
  return GETTYPE_PAGEWISE_VALUES[item];
})));
var FULL_WIDTH_MASTER_TEMPLATES = ["homeMasterTemplate", "brandMasterTemplate", "GenericTemplate", "WdBlogMock", "MasterGenericTemplate", "BaseTemplate"];

var OLD_MASTER_TEMPLATES = ["homeMasterTemplate", "brandMasterTemplate", "collectionMasterTemplate", "categoryMasterTemplate"];
var MASTER_TEMPLATE_COMPONENT_MAPPING_MOBILE = {
  leftNav: "LeftNavMobile"
};

var MY_BAG_OFFER_IMAGE = {
  imageLink: process.env.REACT_APP_MYBAGOFFERIMAGE,
  link: process.env.REACT_APP_MYBAGOFFERLINK
};

var MASTER_TEMPLATE_COMPONENT_MAPPING = {
  blocks: "Blocks",
  leftNav: "LeftNav",
  banner: "Banner",
  topBar: "TopBar",
  heroBanner: "TopBanner",
  topBanner: "TopBanner",
  youtubeVideo: "VideoComponent",
  sephoraCarousel: "BannerCarousel",
  gapCarousel: "BannerCarousel",
  bannerCarousel: "BannerCarousel",
  story: "StoryComponent",
  blogStory: "StoryComponent",
  tertiaryStorySection: "SectionCarousel",
  storyCarousel: "SectionCarousel",
  trendingTitle: "StoryTitle",
  secondaryStoriesTitle: "StoryTitle",
  primaryStories: "StoryMasonry",
  secondaryStories: "StoryMasonry",
  productCarousal: "ProductCarouselComponent",
  quickLinks: "QuickLinksComponent",
  dummy: "DummyComponent",
  brandStoryTitle: "BrandStoryTitle",
  brandStoryLogo: "BrandStoryLogo",
  brandStoryDescription: "BrandStoryDescription",
  NewArrival: "NewArrivalsCarousel",
  brandStory: "BrandStory",
  storyGrid: "StoryGrid",
  paraText: "ParaText",
  logoBand: "LogoBand",
  genericTextBand: "GenericTextBand",
  title: "Title",
  blogHeading: "BlogHeading",
  paddingComponent: "PaddingComponent"
};

var MASTER_TEMPLATE_COMPONENT_CONFIGS = {
  VIDEO: {
    MIN_HEIGHT: {
      DESKTOP: "400px",
      MOBILE: "250px"
    }
  },
  TOP_BAR: {
    SHOW_LOGO: ["brandMasterTemplate"],
    TIMEOUT: 3000,
    ADD_SUCCESS: "Brand Added Successfully",
    REMOVE_SUCCESS: "Brand Removed Successfully",
    LABELS: {
      FAVORITED: "favorited",
      UNFAVORITED: "unfavorited"
    }
  },
  LEFT_NAV: {
    HIDE: ["brandMasterTemplate", "BrandMasterTemplate2", "BrandMasterTemplate3", "HMT2"]
  },
  STORY: {
    SHOW_BORDER: ["ga"]
  },
  PRODUCT_CAROUSEL: {
    ORIGIN: "master_template_product_carousel",
    API_LIMIT: 20,
    SIZES: {
      XS: 4,
      SM: 4,
      MD: 4,
      LG: 6
    }
  },
  BANNER_CAROUSEL: {
    ARROWS: {
      base: "icomoon-sephora_"
    },
    SCROLL_INTERVAL: 5000,
    TRANSITION_TIME: {
      SLOW: 600,
      QUICK: 600
    }
  },
  SECTION_CAROUSEL: {
    SCROLL_INTERVAL: 3000,
    TRANSITION_TIME: {
      SLOW: 600,
      QUICK: 600
    }
  }
};
var PASTEL_COLOR_SET = ["#b5dce1", "#d7e0b1", "#f4e0e9", "#cfdaf0", "#f4e3c9", "#f4d9d0"];

var SOLID_COLOR_SET = ["#33cc66", "#ff3366", "#b2d235", "#2ba2e4", "#ffa500", "#ea0020"];
var BRAND_SPECIFIC_CONFIGS = {
  se: ["showMasterTemplateBrushStroke"]
};

var LOGOUT_DELAY_TIME = 5000;
var STORE_CHECK_LOGOUT = "Dude! You are a staff! Not a customer. Logging out..";
var SOMETHING_FISHY = "Something went wrong, Logging out..";
var MAX_TITLEDESCRIPTIONHORIGENTAL_CHARECTER_DESKTOP = 33;
var MAX_TITLEDESCRIPTIONHORIGENTAL_CHARECTER_MOBILE = 43;
var PINCODE_LENGTH = 6;
var HEADER_HEIGHT = 100;
var OVERFLOW_HIDDEN = "hidden";
var OVERFLOW_AUTO = "auto";
var PIXEL_SCROLLED_LIMIT = 70;
var FOOTER_HIDDEN_PATHS = ["mybag", "store-locator"];
var STATIC_FOOTER_PATHS = ["checkout"];
var APP_PROMPT_KEY = "app";
var APP_PROMPT_VALUE = "show";
var APP_OS = "Android";
var APP_BROWSER = "Chrome";
var APP_PROMPT_MESSAGE = "Open with NNNOW app";
var APP_PROMPT_OK = "OPEN";
var APP_PROMPT_CANCEL = "CANCEL";
var APP_PROMPT_URL = "www.nnnow.com/";
var APP_IMAGE = cdnBasePath$3 + "/client/assets/images/nnnow-logo-beta_1.png";

var MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

var DOMAINREGEX = "^(?:w+://)?([^/]+)(.*)$"; //eslint-disable-line
var PDP_SIZE_CHART_LABEL = "SIZE CHART";
var PDP_SIZE_CHART_NOTE = "Actual measurement may vary marginally depending on the intended fit of the product.";
var PDP_SIZE_BLOCK_TITLE = "SIZE:";
var PDP_SIZE_MODAL_TITLE = "Select size to add to bag";
var PDP_SIZE_MODAL_SUBTEXT = "Not Sure? View";
var SEPHORA_BRANDS = ["FOREST ESSENTIALS", "Bobbi Brown", "DOLCE & GABBANA", "roberto cavalli", "Yves Saint Laurent", "NATIO", "Paco Rabanne", "ZIRH", "MONTBLANC", "stila", "Smashbox", "Oscar Blandi", "MAKE UP FOR EVER", "Versace", "Ermenegildo Zegna", "Sephora Collection", "MARC JACOBS", "Gucci", "Estee Lauder", "Clarins", "PERCY & REED", "PRADA", "Givenchy", "boscia", "Kenzo", "Issey Miyake", "CLINIQUE", "Narciso Rodriguez", "Lacoste", "Benefit Cosmetics", "Tangle Teezer", "GLAMGLOW", "Elizabeth Arden", "MUGLER", "MOSCHINO", "DAVIDOFF", "Salvatore Ferragamo", "TOM FORD", "Calvin Klein Fragrances", "Cartier", "VALENTINO", "AZZARO", "CoSTUME NATIONAL", "NINA RICCI", "COVER FX", "BURBERRY", "SEPHORA", "Omorovicza", "Votre", "Lancome", "O.P.I", "BVLGARI", "Dior", "SHISEIDO", "dunhill", "NYX", "FOREO", "BURT'S BEES", "Hugo Boss", "SOAP & GLORY", "GIORGIO ARMANI", "DIESEL", "RALPH LAUREN", "ELIE SAAB", "Michael Kors", "Carolina Herrera", "Chloe", "BECCA"].map(function (p) {
  return p.toLowerCase();
});

var PINCODE_BLOCK_TITLE = "DELIVERY/STORE OPTIONS :";
var PINCODE_BLOCK_DESCRIPTION = "Enter your pincode to view delivery & store options";
var PINCODE_NOT_SERVICEABLE = "Sorry we don't deliver to this pincode yet. Please try another one.";
var PINCODE_BLOCK_PLACEHOLDER = "";

var MYORDERS_MESSAGES = {
  NOORDER: "You have not placed any orders yet!",
  ERROR_MSG: "Error while fetching your orders!",
  TITLE: "MY ORDERS",
  NOT_LOGGED_IN: "Please Login To Continue",
  LOGIN: "LOGIN"
};
var COPYRIGHT_TEXT = function () {
  return "\xA9 " + new Date().getFullYear() + " NNNOW";
}();

var ADD_NEFT_TITLE = "ADD NEW NEFT DETAILS";

var ADD_NEFT_FORM = {
  accHoldName: "Account Holders Name*",
  bankName: "Bank Name*",
  accNumber: "Account Number*",
  conAccNumber: "Confirm Account Number*",
  branchName: "Branch Name*",
  ifsc: "IFSC Code*",
  accTypeTitle: "Account Type",
  savingsAccType: "Savings",
  currentAccType: "Current",
  submitButton: "SAVE",
  savingsAccountNature: "SB",
  currentAccountNature: "CC",
  conAccNumErrMsg: "Please enter the same Account Number!",
  default_error_msg: "Oops! Something went wrong. Please try again later.",
  minCharAccHoldNameErrMsg: "Name!",
  minCharbankNameErrMsg: "Bank Name!",
  minCharbranchNameErrMsg: "Branch Name!",
  invalidNameErrMsg: "Alphabets only, please",
  accNumberLengthLimit: 18
};

var PDP_PRODUCTVIEWBUTTON_TEXTS = {
  shop: "SHOP NNNOW",
  favourite: "FAVOURITE",
  newText: "NEW IN"
};

var LOGOUT_REDIRECT_PATHS = ["orderconfirmation"];

var GETAPP = {
  LABEL: "Get APP",
  DESKTOP_LABEL: "DOWNLOAD APP",
  PATH: "/apps"
};

var NO_RESULTS = {
  searchTitle: "0 results found for",
  searchPlaceholder: "Search for",
  productCarouselTitle1: "NEW ARRIVALS",
  productCarouselTitle2: "ON SALE",
  toastrMessage: "Please input something to search...",
  newArrivals: "/products?na&sort=newest",
  onSale: "/products?os",
  MIN_SIZE: 20
};
var HIDE_BRANDNAME = process.env.REACT_APP_HIDE_BRANDNAME === "true";

var BLANK_SEARCH_MESSAGE = "Please input something to search!";
var APPS = {
  TITLE: "NNNOW ON THE GO!",
  MESSAGE: "Download our top-rated app, made just for you! It's free, easy and smart.",
  NAME: "MOBILENUMBERFIELD",
  PLACEHOLDER: "Phone number(+91)",
  BUTTON_LABEL: "SEND APP LINK",
  SUCCESS_TITLE: "THANK YOU",
  SUCCESS_MESSAGE: "We’ve just sent a SMS to your phone with the link to download the app.",
  CUSTOMER_BLOCK_TITLE: "CUSTOMER FEEDBACKS",
  CUSTOMER_DETAILS: [{
    ID: 0,
    NAME: "HARIKRISHNAN R NAIR",
    MESSAGE: "Uninterrupted access to fashion on my own terms - where I want, when I want, how I want, also at the price I want. Nnnow has a sense of style and purpose compared to the other online e-commerce portals. Nnnow is clear, cool and connected."
  }, {
    ID: 1,
    NAME: "GOKULNATH SUBRAMANIAN",
    MESSAGE: "Amazing app to buy all my favourite brands at one shot. Several filters make omni Channel buying possible across all categories. Will definitely keep coming back and buying more."
  }],
  APP_STORE_PATH: "https://itunes.apple.com/us/app/nnnow-fashion-shopping-app/id1142544717?mt=8",
  PLAY_STORE_PATH: "https://play.google.com/store/apps/details?id=com.nnnow.arvind&hl=en"
};

var BRANDS_SITE_KEY = ["uspoloassn", "flyingmachine", "aeropostale", "edhardy", "trueblue", "arrow", "arvind", "gant", "stride", "thechildrensplace"];

var GAP_UN_SEPHORA_JOURNEY = ["sephora", "gap", "unlimited"];

var SITE_KEY = {
  BRAND_JOURNEY: "ry09QPJ5mbCNEwokCeKPjUrG-P9TOKDowkif3LKL-QQ",
  DEFAULT: "P5hXMQ-ATML8ShhpCLa_wzcyFwyGRsJdr92b6YuBSIg",
  GAP_UN_SEPHORA: "lRXUhl40gQth49KLZ8fV8vv9fNisI9EXpef4Z1h4lzc"
};

// PdpBannerSlot

var PDP_BANNERSLOT_URL = "/products";
var PRODUCTLISTBANNER = "ProductListBanner";

// PdpNonReturnBlock

var PDP_NONRETURNBLOCK_TEXT1 = "RETURN POLICY ON THIS ITEM";
var PDP_NONRETURNBLOCK_TEXT2 = "This item is non-returnable.";

// Mobile Filter Button

var MOBILE_FILTER_BUTTON = {
  REFINE_BUTTON: "REFINE",
  SORT_BUTTON: "SORT",
  SCROLLX: 0,
  SCROLLY: 100
};
var IFRAME_LISTING_PARAMS = {
  catalogStatus: ["content_done", "image_done", "content_image_done", "content_image_pending"]
};

var STATIC_META_TAG = "app-id=1142544717, app-argument=nnnow://url?url=https://";

var CONTINUE_LOGIN_MESSAGES = {
  OOPS: "OOPS!",
  NOT_LOGGED_IN: "Please Login To Continue",
  LOGIN: "LOGIN"
};

var INSTALL_PROMPT_COMPONENT = {
  TIME_DIFF: 60000
};

var NAV_BUTTON_CONFIG = {
  MAX_COUNT: 3,
  NODE_TYPE: "button_with_border"
};

var STATIC_LOGGEDIN_MENU = {
  MYORDERS: "My Orders",
  FAVORITES: "Favorites"
};

var WISHLIST_TOASTR_MESSAGE = {
  ALREADY_ADDED: "Oops! This product is already in your favourites",
  FAILURE: "Oops! This item has not been added to your favourites.",
  SUCCESS: "Good mooove! This item has been added to your favourites."
};

var LEFT_MOBILE_NAV = {
  MY_ORDERS: "MY ORDERS",
  MY_ACCOUNT: "MY ACCOUNT",
  SIGN_OUT: "SIGN OUT",
  LOGIN: "LOGIN",
  STORE_LOCATOR: "STORE LOCATOR",
  HELP: "HELP"
};

exports.IFRAME_LISTING_PARAMS = IFRAME_LISTING_PARAMS;
exports.HIDE_BRANDNAME = HIDE_BRANDNAME;
exports.BRAND_NAME = BRAND_NAME;
exports.FOOTER_TEXTS = FOOTER_TEXTS;
exports.COPYRIGHT_TEXT = COPYRIGHT_TEXT;
exports.DOMAINREGEX = DOMAINREGEX;
exports.STATIC_FOOTER_PATHS = STATIC_FOOTER_PATHS;
exports.FOOTER_HIDDEN_PATHS = FOOTER_HIDDEN_PATHS;
exports.ROUTE_PATHS = ROUTE_PATHS;
exports.STATIC_HEADER_ROUTES = STATIC_HEADER_ROUTES;
exports.STATIC_GETTYPE_RESPONSE = STATIC_GETTYPE_RESPONSE;
exports.OLD_MASTER_TEMPLATES = OLD_MASTER_TEMPLATES;
exports.SUPPORTED_GETTYPE_VALUES = SUPPORTED_GETTYPE_VALUES;
exports.EXCLUDE_STORY_BACKGROUND_COLOR = EXCLUDE_STORY_BACKGROUND_COLOR;
exports.FULL_WIDTH_MASTER_TEMPLATES = FULL_WIDTH_MASTER_TEMPLATES;
exports.BRAND_SPECIFIC_CONFIGS = BRAND_SPECIFIC_CONFIGS;
exports.PASTEL_COLOR_SET = PASTEL_COLOR_SET;
exports.MASTER_TEMPLATE_COMPONENT_CONFIGS = MASTER_TEMPLATE_COMPONENT_CONFIGS;
exports.MASTER_TEMPLATE_COMPONENT_MAPPING_MOBILE = MASTER_TEMPLATE_COMPONENT_MAPPING_MOBILE;
exports.MASTER_TEMPLATE_COMPONENT_MAPPING = MASTER_TEMPLATE_COMPONENT_MAPPING;
exports.STATIC_ROUTES = STATIC_ROUTES;
exports.GETTYPE_PAGEWISE_VALUES = GETTYPE_PAGEWISE_VALUES;
exports.DONOT_SHOW_OCCASION_FILTER_IDS = DONOT_SHOW_OCCASION_FILTER_IDS;
exports.PDP_CAROUSEL_MAX_LIMIT = PDP_CAROUSEL_MAX_LIMIT;
exports.CACHE_SETTINGS = CACHE_SETTINGS;
exports.STORAGE_KEYS = STORAGE_KEYS;
exports.FB_SHARE_TITLE = FB_SHARE_TITLE;
exports.APP_BREAKPOINTS = APP_BREAKPOINTS;
exports.PDP_CAROUSEL_DEFAULT_VIEWALL_TEXT = PDP_CAROUSEL_DEFAULT_VIEWALL_TEXT;
exports.PDP_CAROUSEL_HEADINGS = PDP_CAROUSEL_HEADINGS;
exports.PDP_CAROUSEL_SIZE = PDP_CAROUSEL_SIZE;
exports.LOGMAN_SERVICE_NAME = LOGMAN_SERVICE_NAME;
exports.PDP_RETURNS = PDP_RETURNS;
exports.subPromoSeparator = subPromoSeparator;
exports.DEF_META_DATA = DEF_META_DATA;
exports.requiredKeysForListing = requiredKeysForListing;
exports.scrollTime = scrollTime;
exports.omniViewimageBasePath = omniViewimageBasePath;
exports.pageType = pageType;
exports.brandFilterKeys = brandFilterKeys;
exports.test = test;
exports.filterKeys = filterKeys;
exports.searchQuerySeparator = searchQuerySeparator;
exports.priceSeparator = priceSeparator;
exports.footerUrls = footerUrls;
exports.gmail = gmail;
exports.facebook = facebook;
exports.filterInitialLength = filterInitialLength;
exports.SOLID_COLOR_SET = SOLID_COLOR_SET;
exports.blackBoltUrl = blackBoltUrl;
exports.blackBoltVersion = blackBoltVersion;
exports.blackboltConfig = blackboltConfig;
exports.expiryTime = expiryTime;
exports.HOME_PAGE_URL = HOME_PAGE_URL;
exports.LOGOUT_DELAY_TIME = LOGOUT_DELAY_TIME;
exports.STORE_CHECK_LOGOUT = STORE_CHECK_LOGOUT;
exports.SOMETHING_FISHY = SOMETHING_FISHY;
exports.MAX_TITLEDESCRIPTIONHORIGENTAL_CHARECTER_DESKTOP = MAX_TITLEDESCRIPTIONHORIGENTAL_CHARECTER_DESKTOP;
exports.MAX_TITLEDESCRIPTIONHORIGENTAL_CHARECTER_MOBILE = MAX_TITLEDESCRIPTIONHORIGENTAL_CHARECTER_MOBILE;
exports.PINCODE_LENGTH = PINCODE_LENGTH;
exports.HEADER_HEIGHT = HEADER_HEIGHT;
exports.OVERFLOW_HIDDEN = OVERFLOW_HIDDEN;
exports.OVERFLOW_AUTO = OVERFLOW_AUTO;
exports.PIXEL_SCROLLED_LIMIT = PIXEL_SCROLLED_LIMIT;
exports.APP_BROWSER = APP_BROWSER;
exports.APP_OS = APP_OS;
exports.APP_PROMPT_KEY = APP_PROMPT_KEY;
exports.APP_PROMPT_VALUE = APP_PROMPT_VALUE;
exports.APP_PROMPT_MESSAGE = APP_PROMPT_MESSAGE;
exports.APP_IMAGE = APP_IMAGE;
exports.APP_PROMPT_OK = APP_PROMPT_OK;
exports.APP_PROMPT_CANCEL = APP_PROMPT_CANCEL;
exports.APP_PROMPT_URL = APP_PROMPT_URL;
exports.AFFILIATE_EXPIRY = AFFILIATE_EXPIRY;
exports.MONTHS = MONTHS;
exports.PINCODE_BLOCK_TITLE = PINCODE_BLOCK_TITLE;
exports.PINCODE_BLOCK_DESCRIPTION = PINCODE_BLOCK_DESCRIPTION;
exports.PINCODE_BLOCK_PLACEHOLDER = PINCODE_BLOCK_PLACEHOLDER;
exports.PINCODE_NOT_SERVICEABLE = PINCODE_NOT_SERVICEABLE;
exports.ADD_NEFT_TITLE = ADD_NEFT_TITLE;
exports.ADD_NEFT_FORM = ADD_NEFT_FORM;
exports.MYORDERS_MESSAGES = MYORDERS_MESSAGES;
exports.MY_BAG_OFFER_IMAGE = MY_BAG_OFFER_IMAGE;
exports.PDP_SIZE_CHART_LABEL = PDP_SIZE_CHART_LABEL;
exports.PDP_SIZE_BLOCK_TITLE = PDP_SIZE_BLOCK_TITLE;
exports.PDP_SIZE_MODAL_TITLE = PDP_SIZE_MODAL_TITLE;
exports.PDP_SIZE_MODAL_SUBTEXT = PDP_SIZE_MODAL_SUBTEXT;
exports.SEPHORA_BRANDS = SEPHORA_BRANDS;
exports.LOGOUT_REDIRECT_PATHS = LOGOUT_REDIRECT_PATHS;
exports.PDP_PRODUCTVIEWBUTTON_TEXTS = PDP_PRODUCTVIEWBUTTON_TEXTS;
exports.GETAPP = GETAPP;
exports.NO_RESULTS = NO_RESULTS;
exports.WHO_WE_ARE = WHO_WE_ARE;
exports.CUSTOMER_CARE = CUSTOMER_CARE;
exports.CONTACT_US = CONTACT_US;
exports.TERMS_AND_CONDITIONS = TERMS_AND_CONDITIONS;
exports.PRIVACY_POLICY = PRIVACY_POLICY;
exports.STATICPAGE_HEADER_COLOR_CLASSES = STATICPAGE_HEADER_COLOR_CLASSES;
exports.BLANK_SEARCH_MESSAGE = BLANK_SEARCH_MESSAGE;
exports.APPS = APPS;
exports.BRANDS_SITE_KEY = BRANDS_SITE_KEY;
exports.GAP_UN_SEPHORA_JOURNEY = GAP_UN_SEPHORA_JOURNEY;
exports.SITE_KEY = SITE_KEY;
exports.PDP_BANNERSLOT_URL = PDP_BANNERSLOT_URL;
exports.PRODUCTLISTBANNER = PRODUCTLISTBANNER;
exports.MOBILE_FILTER_BUTTON = MOBILE_FILTER_BUTTON;
exports.PDP_SIZE_CHART_NOTE = PDP_SIZE_CHART_NOTE;
exports.CONTACT_US_V2 = CONTACT_US_V2;
exports.STATIC_META_TAG = STATIC_META_TAG;
exports.enableCollectionSSR = enableCollectionSSR;
exports.PDP_NONRETURNBLOCK_TEXT1 = PDP_NONRETURNBLOCK_TEXT1;
exports.PDP_NONRETURNBLOCK_TEXT2 = PDP_NONRETURNBLOCK_TEXT2;
exports.CONTINUE_LOGIN_MESSAGES = CONTINUE_LOGIN_MESSAGES;
exports.INSTALL_PROMPT_COMPONENT = INSTALL_PROMPT_COMPONENT;
exports.NAV_BUTTON_CONFIG = NAV_BUTTON_CONFIG;
exports.STATIC_LOGGEDIN_MENU = STATIC_LOGGEDIN_MENU;
exports.WISHLIST_TOASTR_MESSAGE = WISHLIST_TOASTR_MESSAGE;
exports.LEFT_MOBILE_NAV = LEFT_MOBILE_NAV;
exports.Checkout = checkout;
exports.OrderConfirmation = orderConfirmation;
exports.Payment = payment;
exports.Login = login;
exports.RegexMethods = regex;
exports.MASTERTEMPLATE = masterTemplate;
exports.RETURNS = returns;
exports.CANCEL = cancel;
exports.ORDERDETAILS = orderDetails;
exports.MYACCOUNTPAGE = myaccount;
exports.FAVORITESPAGE = favorites;
exports.MAIN_CONFIG = generalConfigs;
exports.Loyalty = loyalty;
exports.CACHINGVALS = caching;
exports.productTags = productTags;
exports.URL_CONFIG = URL_CONFIG;
exports.NOT_FOUND = NOT_FOUND;
exports.Endpoints = apis$1;
exports.MyBag = DATA;
exports.Promotions = PROMOTIONS;
exports.PRICINGOVERVIEW = PRICINGOVERVIEW;
exports.PAYMENTPAGE = PAYMENTPAGE;
exports.PDP_CONFIG = PDP_CONFIG;
exports.SHOP_MULTILPE = SHOP_MULTILPE;
exports.FAVNSHARE = FAVNSHARE;
exports.FOOTER = FOOTER;
exports.LISTING = LISTING;
exports.HEADER = header;
exports.BRANDSLIST = BRANDSLIST;
exports.META = META;
exports.STORE_LOCATOR_TIMINGS = STORE_LOCATOR_TIMINGS;
exports.PRICE_INFO_BLOCK = PRICE_INFO_BLOCK;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/arv-extends/constants/index.js
// module id = 25
// module chunks = 1